function PlanR({ ...props }) {
	return (
		<g id="plan-r">
			<g id="furniture">
				<polyline
					points="831.61 587.17 831.61 589.79 826.44 589.79 826.44 587.17 831.61 587.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="482.77"
					y1="445.14"
					x2="482.77"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.77"
					y1="445.14"
					x2="485.39"
					y2="445.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="445.14"
					x2="485.39"
					y2="450.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="454.01"
					x2="485.39"
					y2="460.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="464.06"
					x2="485.39"
					y2="470.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="474.11"
					x2="485.39"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="484.16"
					x2="485.39"
					y2="490.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="494.21"
					x2="485.39"
					y2="500.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="504.27"
					x2="485.39"
					y2="510.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="514.32"
					x2="485.39"
					y2="520.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="524.37"
					x2="485.39"
					y2="530.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="534.42"
					x2="485.39"
					y2="540.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="544.47"
					x2="485.39"
					y2="550.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="554.53"
					x2="485.39"
					y2="560.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="564.58"
					x2="485.39"
					y2="570.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="574.63"
					x2="485.39"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="579.72"
					x2="491.77"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.77"
					y1="270.53"
					x2="482.77"
					y2="402.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.83"
					y1="270.53"
					x2="495.54"
					y2="270.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.77"
					y1="270.53"
					x2="485.39"
					y2="270.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="270.53"
					x2="485.39"
					y2="274.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="277.86"
					x2="485.39"
					y2="284.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="287.91"
					x2="485.39"
					y2="294.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="297.97"
					x2="485.39"
					y2="304.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="308.02"
					x2="485.39"
					y2="314.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="318.07"
					x2="485.39"
					y2="324.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="328.12"
					x2="485.39"
					y2="334.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="338.18"
					x2="485.39"
					y2="344.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="348.23"
					x2="485.39"
					y2="354.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="358.28"
					x2="485.39"
					y2="364.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="368.33"
					x2="485.39"
					y2="374.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="378.38"
					x2="485.39"
					y2="384.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="388.44"
					x2="485.39"
					y2="394.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="398.49"
					x2="485.39"
					y2="402.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.39"
					y1="402.05"
					x2="491.77"
					y2="402.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.54"
					y1="402.05"
					x2="501.83"
					y2="402.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="366.87 736.05 437.56 736.05 437.56 806.73 366.87 806.73 366.87 736.05"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="808.09 167.6 764.23 167.6 764.23 173.27 808.09 173.27 808.09 167.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="762.16 167.09 810.15 167.09 810.15 167.6 762.16 167.6 762.16 167.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="762.16"
					y1="167.09"
					x2="810.15"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.15"
					y1="167.09"
					x2="810.15"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.15"
					y1="167.6"
					x2="762.16"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.16"
					y1="167.6"
					x2="762.16"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.09"
					y1="173.27"
					x2="764.23"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.23"
					y1="167.6"
					x2="808.09"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="812.73 173.27 808.09 173.27 808.09 167.6 812.73 167.6 812.73 173.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="812.73"
					y1="173.27"
					x2="808.09"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.09"
					y1="173.27"
					x2="808.09"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.09"
					y1="167.6"
					x2="812.73"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.73"
					y1="167.6"
					x2="812.73"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="759.59 167.6 764.23 167.6 764.23 173.27 759.59 173.27 759.59 167.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="759.59"
					y1="167.6"
					x2="764.23"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.23"
					y1="167.6"
					x2="764.23"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.23"
					y1="173.27"
					x2="759.59"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.59"
					y1="173.27"
					x2="759.59"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.09"
					y1="168.63"
					x2="764.23"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="814.79 172.75 812.73 172.75 812.73 167.6 810.15 167.6 810.15 167.09 814.79 167.09 814.79 172.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="814.79"
					y1="172.75"
					x2="812.73"
					y2="172.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.73"
					y1="172.75"
					x2="812.73"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.73"
					y1="167.6"
					x2="810.15"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.15"
					y1="167.6"
					x2="810.15"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.15"
					y1="167.09"
					x2="814.79"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.79"
					y1="167.09"
					x2="814.79"
					y2="172.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="757.53 167.09 762.16 167.09 762.16 167.6 759.59 167.6 759.59 172.75 757.53 172.75 757.53 167.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="757.53"
					y1="167.09"
					x2="762.16"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.16"
					y1="167.09"
					x2="762.16"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.16"
					y1="167.6"
					x2="759.59"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.59"
					y1="167.6"
					x2="759.59"
					y2="172.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.59"
					y1="172.75"
					x2="757.53"
					y2="172.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="172.75"
					x2="757.53"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="754.91 168.63 754.91 171.25 617.53 171.25 617.53 168.63 754.91 168.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="754.91"
					y1="168.63"
					x2="754.91"
					y2="171.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.91"
					y1="171.25"
					x2="617.53"
					y2="171.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="171.25"
					x2="617.53"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="617.53"
					y1="168.63"
					x2="754.91"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="814.79 168.63 820.03 168.63 820.03 184.34 814.79 184.34 814.79 168.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="820.03"
					y1="168.63"
					x2="814.79"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.03"
					y1="184.34"
					x2="820.03"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.79"
					y1="184.34"
					x2="820.03"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.79"
					y1="168.63"
					x2="814.79"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="752.29 168.63 757.53 168.63 757.53 184.34 752.29 184.34 752.29 168.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="757.53"
					y1="168.63"
					x2="752.29"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.53"
					y1="184.34"
					x2="757.53"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.29"
					y1="184.34"
					x2="757.53"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.29"
					y1="168.63"
					x2="752.29"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="614.91 168.63 620.15 168.63 620.15 184.34 614.91 184.34 614.91 168.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="620.15"
					y1="168.63"
					x2="614.91"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.15"
					y1="184.34"
					x2="620.15"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.91"
					y1="184.34"
					x2="620.15"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.91"
					y1="168.63"
					x2="614.91"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="383.17 167.6 341.92 167.6 341.92 173.27 383.17 173.27 383.17 167.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="339.86 167.09 385.23 167.09 385.23 167.6 339.86 167.6 339.86 167.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="339.86"
					y1="167.09"
					x2="385.23"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.23"
					y1="167.09"
					x2="385.23"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.23"
					y1="167.6"
					x2="339.86"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.86"
					y1="167.6"
					x2="339.86"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.17"
					y1="173.27"
					x2="341.92"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.92"
					y1="167.6"
					x2="383.17"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="387.81 173.27 383.17 173.27 383.17 167.6 387.81 167.6 387.81 173.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="387.81"
					y1="173.27"
					x2="383.17"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.17"
					y1="173.27"
					x2="383.17"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.17"
					y1="167.6"
					x2="387.81"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.81"
					y1="167.6"
					x2="387.81"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="337.29 167.6 341.92 167.6 341.92 173.27 337.29 173.27 337.29 167.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="337.29"
					y1="167.6"
					x2="341.92"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.92"
					y1="167.6"
					x2="341.92"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.92"
					y1="173.27"
					x2="337.29"
					y2="173.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.29"
					y1="173.27"
					x2="337.29"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.17"
					y1="168.63"
					x2="341.92"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="389.87 172.75 387.81 172.75 387.81 167.6 385.23 167.6 385.23 167.09 389.87 167.09 389.87 172.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="389.87"
					y1="172.75"
					x2="387.81"
					y2="172.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.81"
					y1="172.75"
					x2="387.81"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.81"
					y1="167.6"
					x2="385.23"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.23"
					y1="167.6"
					x2="385.23"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.23"
					y1="167.09"
					x2="389.87"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.87"
					y1="167.09"
					x2="389.87"
					y2="172.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="335.22 167.09 339.86 167.09 339.86 167.6 337.29 167.6 337.29 172.75 335.22 172.75 335.22 167.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="335.22"
					y1="167.09"
					x2="339.86"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.86"
					y1="167.09"
					x2="339.86"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.86"
					y1="167.6"
					x2="337.29"
					y2="167.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.29"
					y1="167.6"
					x2="337.29"
					y2="172.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.29"
					y1="172.75"
					x2="335.22"
					y2="172.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.22"
					y1="172.75"
					x2="335.22"
					y2="167.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="332.61 168.63 332.61 171.25 223.91 171.25 223.91 168.63 332.61 168.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="332.61"
					y1="168.63"
					x2="332.61"
					y2="171.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.61"
					y1="171.25"
					x2="223.91"
					y2="171.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.91"
					y1="171.25"
					x2="223.91"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.91"
					y1="168.63"
					x2="332.61"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="389.87 168.63 395.11 168.63 395.11 184.34 389.87 184.34 389.87 168.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="395.11"
					y1="168.63"
					x2="389.87"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.11"
					y1="184.34"
					x2="395.11"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.87"
					y1="184.34"
					x2="395.11"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.87"
					y1="168.63"
					x2="389.87"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="329.99 168.63 335.22 168.63 335.22 184.34 329.99 184.34 329.99 168.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="335.22"
					y1="168.63"
					x2="329.99"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.22"
					y1="184.34"
					x2="335.22"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.99"
					y1="184.34"
					x2="335.22"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.99"
					y1="168.63"
					x2="329.99"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.29 168.63 226.52 168.63 226.52 184.34 221.29 184.34 221.29 168.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="226.52"
					y1="168.63"
					x2="221.29"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.52"
					y1="184.34"
					x2="226.52"
					y2="168.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.29"
					y1="184.34"
					x2="226.52"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.29"
					y1="168.63"
					x2="221.29"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.45"
					y1="835.29"
					x2="460.52"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="464.45"
					y1="814.35"
					x2="460.52"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="464.45"
					y1="814.35"
					x2="464.45"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="563.92"
					y1="835.29"
					x2="567.85"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="563.92"
					y1="814.35"
					x2="567.85"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="563.92"
					y1="814.35"
					x2="563.92"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="562.62 836.6 567.85 836.6 567.85 835.29 562.62 835.29 562.62 836.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="465.76 835.29 460.52 835.29 460.52 836.6 465.76 836.6 465.76 835.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="562.62 814.35 567.85 814.35 567.85 813.05 562.62 813.05 562.62 814.35"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="465.76 813.05 460.52 813.05 460.52 814.35 465.76 814.35 465.76 813.05"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="562.62"
					y1="836.6"
					x2="567.85"
					y2="836.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.85"
					y1="836.6"
					x2="567.85"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.85"
					y1="835.29"
					x2="562.62"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.62"
					y1="835.29"
					x2="562.62"
					y2="836.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.76"
					y1="835.29"
					x2="460.52"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.52"
					y1="835.29"
					x2="460.52"
					y2="836.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.52"
					y1="836.6"
					x2="465.76"
					y2="836.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.76"
					y1="836.6"
					x2="465.76"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.62"
					y1="814.35"
					x2="567.85"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.85"
					y1="814.35"
					x2="567.85"
					y2="813.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="567.85"
					y1="813.05"
					x2="562.62"
					y2="813.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="562.62"
					y1="813.05"
					x2="562.62"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.76"
					y1="813.05"
					x2="460.52"
					y2="813.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.52"
					y1="813.05"
					x2="460.52"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.52"
					y1="814.35"
					x2="465.76"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.76"
					y1="814.35"
					x2="465.76"
					y2="813.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="561.31 835.29 563.27 835.29 563.27 814.35 561.31 814.35 561.31 835.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="465.1 835.29 467.07 835.29 467.07 814.35 465.1 814.35 465.1 835.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="533.7 747.71 467.07 814.35 470.31 817.59 536.94 750.96 533.7 747.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="563.27"
					y1="814.35"
					x2="563.92"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.27"
					y1="835.29"
					x2="563.92"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.92"
					y1="814.35"
					x2="563.92"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.1"
					y1="814.35"
					x2="464.45"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.1"
					y1="835.29"
					x2="464.45"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.45"
					y1="814.35"
					x2="464.45"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.31"
					y1="835.29"
					x2="561.31"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="561.31"
					y1="814.35"
					x2="563.27"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.27"
					y1="814.35"
					x2="563.27"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.27"
					y1="835.29"
					x2="561.31"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.1"
					y1="835.29"
					x2="465.1"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.1"
					y1="814.35"
					x2="467.07"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.07"
					y1="814.35"
					x2="467.07"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.07"
					y1="835.29"
					x2="465.1"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.7"
					y1="747.71"
					x2="536.94"
					y2="750.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.94"
					y1="750.96"
					x2="470.31"
					y2="817.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="470.31"
					y1="817.59"
					x2="467.07"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.07"
					y1="814.35"
					x2="533.7"
					y2="747.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.92"
					y1="814.35"
					x2="563.92"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="563.92"
					y1="814.35"
					x2="563.92"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="563.92"
					y1="814.35"
					x2="567.85"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="563.92"
					y1="814.35"
					x2="567.85"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="563.92"
					y1="835.29"
					x2="567.85"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="563.92"
					y1="835.29"
					x2="567.85"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="464.45"
					y1="814.35"
					x2="464.45"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="464.45"
					y1="814.35"
					x2="464.45"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="464.45"
					y1="814.35"
					x2="460.52"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="464.45"
					y1="814.35"
					x2="460.52"
					y2="814.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="464.45"
					y1="835.29"
					x2="460.52"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="464.45"
					y1="835.29"
					x2="460.52"
					y2="835.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="221.29"
					y1="163.4"
					x2="221.29"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="369.98"
					y1="729.23"
					x2="366.06"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="369.98"
					y1="716.14"
					x2="366.06"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="369.98"
					y1="716.14"
					x2="369.98"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="438.05"
					y1="716.14"
					x2="438.05"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="360.58"
					y1="729.23"
					x2="369.98"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="371.29 729.23 366.06 729.23 366.06 730.54 371.29 730.54 371.29 729.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="371.29 714.83 366.06 714.83 366.06 716.14 371.29 716.14 371.29 714.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="436.74"
					y1="729.23"
					x2="436.74"
					y2="730.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.29"
					y1="729.23"
					x2="366.06"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.06"
					y1="729.23"
					x2="366.06"
					y2="730.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.06"
					y1="730.54"
					x2="371.29"
					y2="730.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.29"
					y1="730.54"
					x2="371.29"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.74"
					y1="714.83"
					x2="436.74"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.29"
					y1="714.83"
					x2="366.06"
					y2="714.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.06"
					y1="714.83"
					x2="366.06"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.06"
					y1="716.14"
					x2="371.29"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.29"
					y1="716.14"
					x2="371.29"
					y2="714.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="435.43 729.23 437.39 729.23 437.39 716.14 435.43 716.14 435.43 729.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="370.64 729.23 372.6 729.23 372.6 716.14 370.64 716.14 370.64 729.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="417.03 671.72 372.6 716.14 375.84 719.38 420.27 674.96 417.03 671.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="437.39"
					y1="716.14"
					x2="438.05"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.39"
					y1="729.23"
					x2="438.05"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.05"
					y1="716.14"
					x2="438.05"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.64"
					y1="716.14"
					x2="369.98"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.64"
					y1="729.23"
					x2="369.98"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.98"
					y1="716.14"
					x2="369.98"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.43"
					y1="729.23"
					x2="435.43"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="435.43"
					y1="716.14"
					x2="437.39"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.39"
					y1="716.14"
					x2="437.39"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.39"
					y1="729.23"
					x2="435.43"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.64"
					y1="729.23"
					x2="370.64"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.64"
					y1="716.14"
					x2="372.6"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.6"
					y1="716.14"
					x2="372.6"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.6"
					y1="729.23"
					x2="370.64"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.03"
					y1="671.72"
					x2="420.27"
					y2="674.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="420.27"
					y1="674.96"
					x2="375.84"
					y2="719.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.84"
					y1="719.38"
					x2="372.6"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.6"
					y1="716.14"
					x2="417.03"
					y2="671.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="438.05"
					y1="716.14"
					x2="438.05"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="438.05"
					y1="716.14"
					x2="438.05"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="369.98"
					y1="716.14"
					x2="369.98"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="369.98"
					y1="716.14"
					x2="369.98"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="369.98"
					y1="716.14"
					x2="366.06"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="369.98"
					y1="716.14"
					x2="366.06"
					y2="716.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="369.98"
					y1="729.23"
					x2="366.06"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="369.98"
					y1="729.23"
					x2="366.06"
					y2="729.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="329.66"
					y1="606.84"
					x2="329.66"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="606.84"
					x2="316.56"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="606.84"
					x2="329.66"
					y2="606.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="329.66"
					y1="690.61"
					x2="329.66"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="690.61"
					x2="316.56"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="690.61"
					x2="329.66"
					y2="690.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="330.96 689.3 329.66 689.3 329.66 694.53 330.96 694.53 330.96 689.3"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="329.66 608.14 330.96 608.14 330.96 602.91 329.66 602.91 329.66 608.14"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="316.56 689.3 315.26 689.3 315.26 694.53 316.56 694.53 316.56 689.3"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="315.26 608.14 316.56 608.14 316.56 602.91 315.26 602.91 315.26 608.14"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="330.96"
					y1="689.3"
					x2="330.96"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.96"
					y1="694.53"
					x2="329.66"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="694.53"
					x2="329.66"
					y2="689.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="689.3"
					x2="330.96"
					y2="689.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="608.14"
					x2="329.66"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="602.91"
					x2="330.96"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.96"
					y1="602.91"
					x2="330.96"
					y2="608.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.96"
					y1="608.14"
					x2="329.66"
					y2="608.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="689.3"
					x2="316.56"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="694.53"
					x2="315.26"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.26"
					y1="694.53"
					x2="315.26"
					y2="689.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.26"
					y1="689.3"
					x2="316.56"
					y2="689.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.26"
					y1="608.14"
					x2="315.26"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.26"
					y1="602.91"
					x2="316.56"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="602.91"
					x2="316.56"
					y2="608.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="608.14"
					x2="315.26"
					y2="608.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="329.66 687.99 316.56 687.99 316.56 689.95 329.66 689.95 329.66 687.99"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="329.66 607.49 316.56 607.49 316.56 609.45 329.66 609.45 329.66 607.49"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="261.03 664.99 264.27 668.22 319.81 612.69 316.56 609.45 261.03 664.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="316.56"
					y1="689.95"
					x2="316.56"
					y2="690.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="689.95"
					x2="329.66"
					y2="690.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="690.61"
					x2="329.66"
					y2="690.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="607.49"
					x2="316.56"
					y2="606.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="607.49"
					x2="329.66"
					y2="606.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="606.84"
					x2="329.66"
					y2="606.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="687.99"
					x2="316.56"
					y2="687.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="687.99"
					x2="316.56"
					y2="689.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="689.95"
					x2="329.66"
					y2="689.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="689.95"
					x2="329.66"
					y2="687.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="607.49"
					x2="316.56"
					y2="607.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="607.49"
					x2="316.56"
					y2="609.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="609.45"
					x2="329.66"
					y2="609.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="329.66"
					y1="609.45"
					x2="329.66"
					y2="607.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.03"
					y1="664.99"
					x2="264.27"
					y2="668.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.27"
					y1="668.22"
					x2="319.81"
					y2="612.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.81"
					y1="612.69"
					x2="316.56"
					y2="609.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="609.45"
					x2="261.03"
					y2="664.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.56"
					y1="690.61"
					x2="329.66"
					y2="690.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="690.61"
					x2="329.66"
					y2="690.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="690.61"
					x2="316.56"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="690.61"
					x2="316.56"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="329.66"
					y1="690.61"
					x2="329.66"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="329.66"
					y1="690.61"
					x2="329.66"
					y2="694.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="606.84"
					x2="329.66"
					y2="606.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="606.84"
					x2="329.66"
					y2="606.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="606.84"
					x2="316.56"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="316.56"
					y1="606.84"
					x2="316.56"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="329.66"
					y1="606.84"
					x2="329.66"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="329.66"
					y1="606.84"
					x2="329.66"
					y2="602.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="437.33"
					y1="592.81"
					x2="441.26"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="437.33"
					y1="579.72"
					x2="441.26"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="437.33"
					y1="579.72"
					x2="437.33"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.56"
					y1="592.81"
					x2="349.63"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.56"
					y1="579.72"
					x2="349.63"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.56"
					y1="579.72"
					x2="353.56"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="354.87 594.12 354.87 592.81 349.63 592.81 349.63 594.12 354.87 594.12"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="436.02 592.81 436.02 594.12 441.26 594.12 441.26 592.81 436.02 592.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="354.87 579.72 354.87 578.41 349.63 578.41 349.63 579.72 354.87 579.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="436.02 578.41 436.02 579.72 441.26 579.72 441.26 578.41 436.02 578.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.87"
					y1="594.12"
					x2="349.63"
					y2="594.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.63"
					y1="594.12"
					x2="349.63"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.63"
					y1="592.81"
					x2="354.87"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.87"
					y1="592.81"
					x2="354.87"
					y2="594.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.02"
					y1="592.81"
					x2="441.26"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.26"
					y1="592.81"
					x2="441.26"
					y2="594.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.26"
					y1="594.12"
					x2="436.02"
					y2="594.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.02"
					y1="594.12"
					x2="436.02"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.87"
					y1="579.72"
					x2="349.63"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.63"
					y1="579.72"
					x2="349.63"
					y2="578.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.63"
					y1="578.41"
					x2="354.87"
					y2="578.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.87"
					y1="578.41"
					x2="354.87"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.02"
					y1="578.41"
					x2="441.26"
					y2="578.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.26"
					y1="578.41"
					x2="441.26"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.26"
					y1="579.72"
					x2="436.02"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.02"
					y1="579.72"
					x2="436.02"
					y2="578.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="356.18 592.81 356.18 579.72 354.22 579.72 354.22 592.81 356.18 592.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="436.68 592.81 436.68 579.72 434.72 579.72 434.72 592.81 436.68 592.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="379.18 524.19 375.94 527.43 431.47 582.96 434.72 579.72 379.18 524.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="354.22"
					y1="579.72"
					x2="353.56"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.22"
					y1="592.81"
					x2="353.56"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.56"
					y1="579.72"
					x2="353.56"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.68"
					y1="579.72"
					x2="437.33"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.68"
					y1="592.81"
					x2="437.33"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.33"
					y1="579.72"
					x2="437.33"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.18"
					y1="592.81"
					x2="356.18"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.18"
					y1="579.72"
					x2="354.22"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.22"
					y1="579.72"
					x2="354.22"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="354.22"
					y1="592.81"
					x2="356.18"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.68"
					y1="592.81"
					x2="436.68"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="436.68"
					y1="579.72"
					x2="434.72"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.72"
					y1="579.72"
					x2="434.72"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.72"
					y1="592.81"
					x2="436.68"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.18"
					y1="524.19"
					x2="375.94"
					y2="527.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.94"
					y1="527.43"
					x2="431.47"
					y2="582.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="431.47"
					y1="582.96"
					x2="434.72"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="434.72"
					y1="579.72"
					x2="379.18"
					y2="524.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.56"
					y1="579.72"
					x2="353.56"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.56"
					y1="579.72"
					x2="353.56"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.56"
					y1="579.72"
					x2="349.63"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.56"
					y1="579.72"
					x2="349.63"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.56"
					y1="592.81"
					x2="349.63"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="353.56"
					y1="592.81"
					x2="349.63"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="437.33"
					y1="579.72"
					x2="437.33"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="437.33"
					y1="579.72"
					x2="437.33"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="437.33"
					y1="579.72"
					x2="441.26"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="437.33"
					y1="579.72"
					x2="441.26"
					y2="579.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="437.33"
					y1="592.81"
					x2="441.26"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="437.33"
					y1="592.81"
					x2="441.26"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="572.74"
					x2="463.06"
					y2="576.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="572.74"
					x2="463.06"
					y2="572.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="572.74"
					x2="449.97"
					y2="576.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="572.74"
					x2="460.44"
					y2="572.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="451.01"
					x2="463.06"
					y2="447.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="451.01"
					x2="463.06"
					y2="451.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="451.01"
					x2="449.97"
					y2="447.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="451.01"
					x2="460.44"
					y2="451.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="397.43"
					x2="463.06"
					y2="400.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="397.43"
					x2="463.06"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="397.43"
					x2="449.97"
					y2="400.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="397.43"
					x2="460.44"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="275.7"
					x2="463.06"
					y2="272.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="275.7"
					x2="463.06"
					y2="275.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="275.7"
					x2="449.97"
					y2="272.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="275.7"
					x2="460.44"
					y2="275.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="451.01"
					x2="463.06"
					y2="445.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="402.05"
					x2="463.06"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="275.7"
					x2="463.06"
					y2="270.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="460.44 452.98 463.06 452.98 463.06 451.67 460.44 451.67 460.44 452.98"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="464.37 452.98 464.37 447.74 463.06 447.74 463.06 452.98 464.37 452.98"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="460.44 572.09 463.06 572.09 463.06 570.78 460.44 570.78 460.44 572.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="463.06 570.78 463.06 576.01 464.37 576.01 464.37 570.78 463.06 570.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="449.97 452.98 449.97 447.74 446.7 447.74 446.7 452.98 449.97 452.98"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="446.7 570.78 446.7 576.01 449.97 576.01 449.97 570.78 446.7 570.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="460.44"
					y1="452.98"
					x2="463.06"
					y2="452.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="452.98"
					x2="463.06"
					y2="451.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="451.67"
					x2="460.44"
					y2="451.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="451.67"
					x2="460.44"
					y2="452.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.37"
					y1="452.98"
					x2="464.37"
					y2="447.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.37"
					y1="447.74"
					x2="463.06"
					y2="447.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="447.74"
					x2="463.06"
					y2="452.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="452.98"
					x2="464.37"
					y2="452.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="572.09"
					x2="463.06"
					y2="572.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="572.09"
					x2="463.06"
					y2="570.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="570.78"
					x2="460.44"
					y2="570.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="570.78"
					x2="460.44"
					y2="572.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="570.78"
					x2="463.06"
					y2="576.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="576.01"
					x2="464.37"
					y2="576.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.37"
					y1="576.01"
					x2="464.37"
					y2="570.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.37"
					y1="570.78"
					x2="463.06"
					y2="570.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="452.98"
					x2="449.97"
					y2="447.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="447.74"
					x2="446.7"
					y2="447.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.7"
					y1="447.74"
					x2="446.7"
					y2="452.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.7"
					y1="452.98"
					x2="449.97"
					y2="452.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.7"
					y1="570.78"
					x2="446.7"
					y2="576.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.7"
					y1="576.01"
					x2="449.97"
					y2="576.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="576.01"
					x2="449.97"
					y2="570.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="570.78"
					x2="446.7"
					y2="570.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="460.44 456.9 460.44 451.67 449.97 451.67 449.97 456.9 460.44 456.9"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="460.44 572.09 460.44 566.85 449.97 566.85 449.97 572.09 460.44 572.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="449.97 509.26 449.97 566.85 454.55 566.85 454.55 509.26 449.97 509.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="454.55 488.32 454.55 545.91 459.13 545.91 459.13 488.32 454.55 488.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="449.97"
					y1="451.67"
					x2="449.97"
					y2="451.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="451.67"
					x2="460.44"
					y2="451.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="451.01"
					x2="460.44"
					y2="451.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="572.09"
					x2="449.97"
					y2="572.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="572.09"
					x2="460.44"
					y2="572.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="572.74"
					x2="460.44"
					y2="572.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="456.9"
					x2="449.97"
					y2="456.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="456.9"
					x2="449.97"
					y2="451.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="451.67"
					x2="460.44"
					y2="451.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="451.67"
					x2="460.44"
					y2="456.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="572.09"
					x2="449.97"
					y2="572.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="572.09"
					x2="449.97"
					y2="566.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="566.85"
					x2="460.44"
					y2="566.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="566.85"
					x2="460.44"
					y2="572.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="509.26"
					x2="454.55"
					y2="509.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.55"
					y1="509.26"
					x2="454.55"
					y2="566.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.55"
					y1="566.85"
					x2="449.97"
					y2="566.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="566.85"
					x2="449.97"
					y2="509.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.55"
					y1="488.32"
					x2="459.13"
					y2="488.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.13"
					y1="488.32"
					x2="459.13"
					y2="545.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.13"
					y1="545.91"
					x2="454.55"
					y2="545.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.55"
					y1="545.91"
					x2="454.55"
					y2="488.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="451.01"
					x2="460.44"
					y2="451.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="451.01"
					x2="460.44"
					y2="451.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="451.01"
					x2="463.06"
					y2="451.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="451.01"
					x2="449.97"
					y2="447.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="451.01"
					x2="463.06"
					y2="451.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="451.01"
					x2="463.06"
					y2="447.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="451.01"
					x2="463.06"
					y2="447.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="572.74"
					x2="460.44"
					y2="572.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="572.74"
					x2="460.44"
					y2="572.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="572.74"
					x2="463.06"
					y2="572.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="572.74"
					x2="449.97"
					y2="576.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="572.74"
					x2="463.06"
					y2="572.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="572.74"
					x2="463.06"
					y2="576.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="572.74"
					x2="463.06"
					y2="576.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="460.44 277.66 463.06 277.66 463.06 276.35 460.44 276.35 460.44 277.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="464.37 277.66 464.37 272.42 463.06 272.42 463.06 277.66 464.37 277.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="460.44 396.77 463.06 396.77 463.06 395.46 460.44 395.46 460.44 396.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="463.06 395.46 463.06 400.7 464.37 400.7 464.37 395.46 463.06 395.46"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="449.97 277.66 449.97 272.42 446.7 272.42 446.7 277.66 449.97 277.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="446.7 395.46 446.7 400.7 449.97 400.7 449.97 395.46 446.7 395.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="460.44"
					y1="277.66"
					x2="463.06"
					y2="277.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="277.66"
					x2="463.06"
					y2="276.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="276.35"
					x2="460.44"
					y2="276.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="276.35"
					x2="460.44"
					y2="277.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.37"
					y1="277.66"
					x2="464.37"
					y2="272.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.37"
					y1="272.42"
					x2="463.06"
					y2="272.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="272.42"
					x2="463.06"
					y2="277.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="277.66"
					x2="464.37"
					y2="277.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="396.77"
					x2="463.06"
					y2="396.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="396.77"
					x2="463.06"
					y2="395.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="395.46"
					x2="460.44"
					y2="395.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="395.46"
					x2="460.44"
					y2="396.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="395.46"
					x2="463.06"
					y2="400.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.06"
					y1="400.7"
					x2="464.37"
					y2="400.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.37"
					y1="400.7"
					x2="464.37"
					y2="395.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.37"
					y1="395.46"
					x2="463.06"
					y2="395.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="277.66"
					x2="449.97"
					y2="272.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="272.42"
					x2="446.7"
					y2="272.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.7"
					y1="272.42"
					x2="446.7"
					y2="277.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.7"
					y1="277.66"
					x2="449.97"
					y2="277.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.7"
					y1="395.46"
					x2="446.7"
					y2="400.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.7"
					y1="400.7"
					x2="449.97"
					y2="400.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="400.7"
					x2="449.97"
					y2="395.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="395.46"
					x2="446.7"
					y2="395.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="460.44 281.59 460.44 276.35 449.97 276.35 449.97 281.59 460.44 281.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="460.44 396.77 460.44 391.53 449.97 391.53 449.97 396.77 460.44 396.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="449.97 333.94 449.97 391.53 454.55 391.53 454.55 333.94 449.97 333.94"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="454.55 313 454.55 370.59 459.13 370.59 459.13 313 454.55 313"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="449.97"
					y1="276.35"
					x2="449.97"
					y2="275.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="276.35"
					x2="460.44"
					y2="275.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="275.7"
					x2="460.44"
					y2="275.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="396.77"
					x2="449.97"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="396.77"
					x2="460.44"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="397.43"
					x2="460.44"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="281.59"
					x2="449.97"
					y2="281.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="281.59"
					x2="449.97"
					y2="276.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="276.35"
					x2="460.44"
					y2="276.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="276.35"
					x2="460.44"
					y2="281.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="396.77"
					x2="449.97"
					y2="396.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="396.77"
					x2="449.97"
					y2="391.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="391.53"
					x2="460.44"
					y2="391.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.44"
					y1="391.53"
					x2="460.44"
					y2="396.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="333.94"
					x2="454.55"
					y2="333.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.55"
					y1="333.94"
					x2="454.55"
					y2="391.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.55"
					y1="391.53"
					x2="449.97"
					y2="391.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="391.53"
					x2="449.97"
					y2="333.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.55"
					y1="313"
					x2="459.13"
					y2="313"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.13"
					y1="313"
					x2="459.13"
					y2="370.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.13"
					y1="370.59"
					x2="454.55"
					y2="370.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.55"
					y1="370.59"
					x2="454.55"
					y2="313"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.97"
					y1="275.7"
					x2="460.44"
					y2="275.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="275.7"
					x2="460.44"
					y2="275.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="275.7"
					x2="463.06"
					y2="275.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="275.7"
					x2="449.97"
					y2="272.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="275.7"
					x2="463.06"
					y2="275.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="275.7"
					x2="463.06"
					y2="272.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="275.7"
					x2="463.06"
					y2="272.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="397.43"
					x2="460.44"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="397.43"
					x2="460.44"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="397.43"
					x2="463.06"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="449.97"
					y1="397.43"
					x2="449.97"
					y2="400.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="460.44"
					y1="397.43"
					x2="463.06"
					y2="397.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="397.43"
					x2="463.06"
					y2="400.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="463.06"
					y1="397.43"
					x2="463.06"
					y2="400.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="149.96"
					y1="746.57"
					x2="136.87"
					y2="746.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="136.87"
					y1="746.57"
					x2="70.94"
					y2="746.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="929.06"
					y1="592.41"
					x2="904.17"
					y2="592.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="904.17"
					y1="592.41"
					x2="904.17"
					y2="605.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="614.91"
					y1="184.34"
					x2="614.91"
					y2="163.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="395.11"
					y1="163.4"
					x2="395.11"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="820.03"
					y1="163.4"
					x2="820.03"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="674.99 732.03 674.99 791.77 733.7 791.77 733.7 732.03 674.99 732.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="733.7"
					y1="732.03"
					x2="731.36"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.59"
					y1="732.03"
					x2="721.31"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.54"
					y1="732.03"
					x2="711.26"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.49"
					y1="732.03"
					x2="701.2"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.44"
					y1="732.03"
					x2="691.15"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.38"
					y1="732.03"
					x2="681.1"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="677.33"
					y1="732.03"
					x2="674.99"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.7"
					y1="791.77"
					x2="733.7"
					y2="788.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.7"
					y1="785.14"
					x2="733.7"
					y2="778.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.7"
					y1="775.09"
					x2="733.7"
					y2="768.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.7"
					y1="765.04"
					x2="733.7"
					y2="758.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.7"
					y1="754.99"
					x2="733.7"
					y2="748.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.7"
					y1="744.94"
					x2="733.7"
					y2="738.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.7"
					y1="734.88"
					x2="733.7"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.99"
					y1="791.77"
					x2="677.33"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="681.1"
					y1="791.77"
					x2="687.38"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="691.15"
					y1="791.77"
					x2="697.44"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.2"
					y1="791.77"
					x2="707.49"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.26"
					y1="791.77"
					x2="717.54"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.31"
					y1="791.77"
					x2="727.59"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="731.36"
					y1="791.77"
					x2="733.7"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.99"
					y1="732.03"
					x2="674.99"
					y2="734.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.99"
					y1="738.65"
					x2="674.99"
					y2="744.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.99"
					y1="748.7"
					x2="674.99"
					y2="754.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.99"
					y1="758.76"
					x2="674.99"
					y2="765.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.99"
					y1="768.81"
					x2="674.99"
					y2="775.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.99"
					y1="778.86"
					x2="674.99"
					y2="785.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="674.99"
					y1="788.91"
					x2="674.99"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="733.47 728.94 733.47 727.13 675.22 727.13 675.22 728.94 684.36 728.94 684.36 727.46 724.34 727.46 724.34 728.94 733.47 728.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="724.34"
					y1="728.94"
					x2="733.47"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="724.34"
					y1="727.46"
					x2="724.34"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="684.36"
					y1="727.46"
					x2="724.34"
					y2="727.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="684.36"
					y1="728.94"
					x2="684.36"
					y2="727.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="675.22"
					y1="728.94"
					x2="684.36"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="675.22"
					y1="727.13"
					x2="675.22"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="733.47"
					y1="727.13"
					x2="675.22"
					y2="727.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="733.47"
					y1="728.94"
					x2="733.47"
					y2="727.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<polyline
					points="735.76 728.94 672.93 728.94 672.93 732.03 735.76 732.03 735.76 728.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="735.76"
					y1="732.03"
					x2="735.76"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="672.93"
					y1="732.03"
					x2="735.76"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="672.93"
					y1="728.94"
					x2="672.93"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="735.76"
					y1="728.94"
					x2="672.93"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="675.22"
					y1="728.94"
					x2="675.22"
					y2="727.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="675.22"
					y1="727.13"
					x2="733.47"
					y2="727.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.47"
					y1="727.13"
					x2="733.47"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.93"
					y1="728.94"
					x2="735.76"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.34"
					y1="728.94"
					x2="724.34"
					y2="727.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.34"
					y1="727.46"
					x2="684.36"
					y2="727.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="684.36"
					y1="727.46"
					x2="684.36"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="672.93"
					y1="732.03"
					x2="672.93"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.76"
					y1="728.94"
					x2="735.76"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.76"
					y1="732.03"
					x2="672.93"
					y2="732.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="831.61 506.72 831.61 592.41 929.06 592.41 929.06 506.72 831.61 506.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="929.06"
					y1="506.72"
					x2="831.61"
					y2="506.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="929.06"
					y1="592.41"
					x2="929.06"
					y2="506.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.61"
					y1="592.41"
					x2="929.06"
					y2="592.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.61"
					y1="506.72"
					x2="831.61"
					y2="592.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="838.16"
					y1="506.72"
					x2="838.16"
					y2="592.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="836.11 620.82 836.11 699.35 904.17 699.35 904.17 620.82 836.11 620.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="836.11"
					y1="620.82"
					x2="836.11"
					y2="699.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.17"
					y1="620.82"
					x2="904.17"
					y2="699.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.11"
					y1="620.82"
					x2="902.11"
					y2="699.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.11"
					y1="620.82"
					x2="904.17"
					y2="620.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="836.11"
					y1="699.35"
					x2="904.17"
					y2="699.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.2"
					y1="625.97"
					x2="839.2"
					y2="694.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.2"
					y1="694.2"
					x2="841.26"
					y2="696.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.26"
					y1="696.26"
					x2="899.02"
					y2="696.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.02"
					y1="696.26"
					x2="901.08"
					y2="694.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.08"
					y1="694.2"
					x2="901.08"
					y2="625.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.08"
					y1="625.97"
					x2="899.02"
					y2="623.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="899.02"
					y1="623.91"
					x2="841.26"
					y2="623.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.26"
					y1="623.91"
					x2="839.2"
					y2="625.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m863.43,640.45c0-5.69-4.61-10.31-10.31-10.31s-10.31,4.62-10.31,10.31,4.62,10.31,10.31,10.31,10.31-4.61,10.31-10.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m894.88,640.45c0-4.27-3.46-7.73-7.73-7.73s-7.73,3.46-7.73,7.73,3.46,7.73,7.73,7.73,7.73-3.46,7.73-7.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m860.85,679.72c0-4.27-3.46-7.73-7.73-7.73s-7.73,3.46-7.73,7.73,3.46,7.73,7.73,7.73,7.73-3.46,7.73-7.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m897.46,679.72c0-5.69-4.62-10.31-10.31-10.31s-10.31,4.61-10.31,10.31,4.61,10.31,10.31,10.31,10.31-4.61,10.31-10.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="798.74 734.17 744.77 734.17 743.74 734.45 742.99 735.2 742.71 736.24 742.71 789.7 742.99 790.74 743.74 791.49 744.77 791.77 798.74 791.77 799.77 791.49 800.52 790.74 800.8 789.7 800.8 736.24 800.52 735.2 799.77 734.45 798.74 734.17"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m798.74,734.17c1.14,0,2.06.92,2.06,2.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.8"
					y1="789.7"
					x2="800.8"
					y2="736.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m800.8,789.7c0,1.14-.93,2.06-2.06,2.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.77"
					y1="791.77"
					x2="798.74"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m744.77,791.77c-1.14,0-2.06-.92-2.06-2.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.71"
					y1="736.24"
					x2="742.71"
					y2="789.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m742.71,736.24c0-1.14.92-2.06,2.06-2.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.74"
					y1="734.17"
					x2="744.77"
					y2="734.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.59"
					y1="739.33"
					x2="749.93"
					y2="739.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.86"
					y1="741.39"
					x2="747.86"
					y2="779.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.93"
					y1="781.46"
					x2="793.59"
					y2="781.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.64"
					y1="779.4"
					x2="795.64"
					y2="741.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.59"
					y1="739.33"
					x2="793.59"
					y2="739.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m747.86,741.39c0-1.14.92-2.06,2.06-2.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m749.93,781.46c-1.14,0-2.06-.92-2.06-2.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m795.64,779.4c0,1.14-.92,2.06-2.06,2.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m793.59,739.33c1.14,0,2.06.92,2.06,2.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m774.85,771.15c0-1.71-1.38-3.09-3.09-3.09s-3.09,1.38-3.09,3.09,1.39,3.09,3.09,3.09,3.09-1.38,3.09-3.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="772.68 768.28 772.41 767.62 771.75 767.35 771.1 767.63 770.83 768.28 770.83 788.67 771.1 789.33 771.76 789.6 772.41 789.33 772.68 788.67 772.68 768.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="772.68"
					y1="788.67"
					x2="772.68"
					y2="768.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m772.68,788.67c0,.51-.42.93-.93.93s-.93-.42-.93-.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.83"
					y1="768.28"
					x2="770.83"
					y2="788.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m770.83,768.28h0c0-.52.42-.93.93-.93s.93.41.93.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="773.81 783.42 772.68 783.42 772.68 788.67 772.41 789.33 771.76 789.6 771.1 789.33 770.83 788.67 770.83 783.42 769.7 783.42 769.7 790.12 773.81 790.12 773.81 783.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="773.81"
					y1="790.12"
					x2="773.81"
					y2="783.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.7"
					y1="790.12"
					x2="773.81"
					y2="790.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.7"
					y1="783.42"
					x2="769.7"
					y2="790.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.83"
					y1="783.42"
					x2="769.7"
					y2="783.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.83"
					y1="788.67"
					x2="770.83"
					y2="783.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m772.68,788.67c0,.51-.42.93-.93.93s-.93-.42-.93-.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.68"
					y1="783.42"
					x2="772.68"
					y2="788.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.81"
					y1="783.42"
					x2="772.68"
					y2="783.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="773.78 779.71 772.68 779.71 772.68 783.31 773.78 783.31 773.78 779.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="773.78"
					y1="783.31"
					x2="773.78"
					y2="779.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.68"
					y1="783.31"
					x2="773.78"
					y2="783.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="772.68"
					y1="779.71"
					x2="772.68"
					y2="783.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.78"
					y1="779.71"
					x2="772.68"
					y2="779.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="769.72 779.71 769.72 783.31 770.83 783.31 770.83 779.71 769.72 779.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="770.83"
					y1="779.71"
					x2="769.72"
					y2="779.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.83"
					y1="783.31"
					x2="770.83"
					y2="779.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.72"
					y1="783.31"
					x2="770.83"
					y2="783.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.72"
					y1="779.71"
					x2="769.72"
					y2="783.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="277.81 701.2 273.14 699.12 268.07 698.4 263.01 699.12 258.34 701.2 255.26 703.85 252.92 707.17 251.19 710.97 249.96 714.96 249.04 719.79 248.93 724.71 249.63 729.58 251.11 734.27 250.97 740.03 249.51 745.6 246.82 750.7 245.41 752.91 244.1 755.87 243.61 759.08 244 762.3 244.75 764.21 244.75 769.29 246.87 769.29 246.87 766.97 250.41 769.12 254.48 769.95 281.67 769.95 284.91 769.41 287.86 767.95 290.24 765.69 291.86 762.83 292.57 759.62 292.57 758.99 292.02 755.72 290.83 753.05 289.27 750.58 286.59 745.54 285.15 740.03 285 734.33 286.51 729.63 287.21 724.75 287.11 719.81 286.19 714.96 284.95 710.97 283.22 707.17 280.89 703.85 277.81 701.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="258.38"
					y1="745.78"
					x2="277.76"
					y2="745.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.67"
					y1="769.95"
					x2="268.07"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.67"
					y1="768.97"
					x2="268.07"
					y2="768.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.48"
					y1="769.95"
					x2="268.07"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.48"
					y1="768.97"
					x2="268.07"
					y2="768.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.26"
					y1="745.78"
					x2="277.26"
					y2="749.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.26"
					y1="749.4"
					x2="274.26"
					y2="749.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.26"
					y1="749.4"
					x2="274.26"
					y2="745.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.89"
					y1="745.78"
					x2="258.89"
					y2="749.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.89"
					y1="749.4"
					x2="261.88"
					y2="749.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.88"
					y1="749.4"
					x2="261.88"
					y2="745.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.87"
					y1="760.29"
					x2="246.87"
					y2="769.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.75"
					y1="760.29"
					x2="244.75"
					y2="769.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.75"
					y1="769.29"
					x2="246.87"
					y2="769.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.75"
					y1="760.29"
					x2="246.87"
					y2="760.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.07"
					y1="698.39"
					x2="271.32"
					y2="698.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.32"
					y1="698.77"
					x2="274.46"
					y2="699.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.46"
					y1="699.6"
					x2="277.81"
					y2="701.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.81"
					y1="701.2"
					x2="279.45"
					y2="702.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.45"
					y1="702.42"
					x2="280.89"
					y2="703.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.89"
					y1="703.84"
					x2="283.22"
					y2="707.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.22"
					y1="707.17"
					x2="284.94"
					y2="710.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.94"
					y1="710.95"
					x2="286.19"
					y2="714.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.19"
					y1="714.96"
					x2="286.9"
					y2="718.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.9"
					y1="718.18"
					x2="287.32"
					y2="721.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.32"
					y1="721.44"
					x2="287.38"
					y2="724.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.38"
					y1="724.71"
					x2="287.01"
					y2="727.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.01"
					y1="727.97"
					x2="285.54"
					y2="733.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.54"
					y1="733.02"
					x2="283.25"
					y2="737.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.25"
					y1="737.91"
					x2="280.53"
					y2="742.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.53"
					y1="742.28"
					x2="277.76"
					y2="745.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285"
					y1="734.33"
					x2="285.03"
					y2="738.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.03"
					y1="738.87"
					x2="285.78"
					y2="743.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.78"
					y1="743.29"
					x2="286.55"
					y2="745.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.55"
					y1="745.67"
					x2="287.65"
					y2="748.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.65"
					y1="748.02"
					x2="289.84"
					y2="751.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.84"
					y1="751.45"
					x2="291.77"
					y2="755"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.77"
					y1="755"
					x2="292.29"
					y2="756.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.29"
					y1="756.71"
					x2="292.54"
					y2="758.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.54"
					y1="758.46"
					x2="292.53"
					y2="760.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.53"
					y1="760.21"
					x2="292.25"
					y2="761.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="292.25"
					y1="761.92"
					x2="291.71"
					y2="763.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.71"
					y1="763.55"
					x2="290.9"
					y2="765.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.9"
					y1="765.06"
					x2="289.84"
					y2="766.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.84"
					y1="766.41"
					x2="288.53"
					y2="767.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.53"
					y1="767.58"
					x2="286.21"
					y2="768.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.21"
					y1="768.87"
					x2="283.99"
					y2="769.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="283.99"
					y1="769.58"
					x2="281.67"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="281.67"
					y1="768.97"
					x2="282.71"
					y2="768.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.71"
					y1="768.87"
					x2="284.84"
					y2="768.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="284.84"
					y1="768.21"
					x2="285.88"
					y2="767.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.88"
					y1="767.51"
					x2="286.73"
					y2="766.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="286.73"
					y1="766.61"
					x2="287.92"
					y2="764.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.92"
					y1="764.4"
					x2="288.48"
					y2="761.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.48"
					y1="761.48"
					x2="288.61"
					y2="758.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.61"
					y1="758.47"
					x2="288.59"
					y2="756.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.59"
					y1="756.98"
					x2="288.39"
					y2="756.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.39"
					y1="756.31"
					x2="287.96"
					y2="755.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.96"
					y1="755.79"
					x2="287.23"
					y2="755.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.23"
					y1="755.44"
					x2="279"
					y2="753.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279"
					y1="753.11"
					x2="274.91"
					y2="752.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.91"
					y1="752.41"
					x2="270.77"
					y2="752.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.77"
					y1="752.11"
					x2="268.07"
					y2="752.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.11"
					y1="734.27"
					x2="251.08"
					y2="738.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.08"
					y1="738.82"
					x2="250.34"
					y2="743.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.34"
					y1="743.26"
					x2="249.58"
					y2="745.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.58"
					y1="745.65"
					x2="248.49"
					y2="748.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.49"
					y1="748.02"
					x2="246.31"
					y2="751.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.31"
					y1="751.46"
					x2="244.38"
					y2="755"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="244.38"
					y1="755"
					x2="243.74"
					y2="757.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.74"
					y1="757.31"
					x2="243.59"
					y2="759.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.59"
					y1="759.69"
					x2="243.92"
					y2="762.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="243.92"
					y1="762.02"
					x2="244.75"
					y2="764.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="254.48"
					y1="768.97"
					x2="253.44"
					y2="768.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.44"
					y1="768.87"
					x2="251.3"
					y2="768.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.3"
					y1="768.21"
					x2="250.27"
					y2="767.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.27"
					y1="767.51"
					x2="249.41"
					y2="766.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.41"
					y1="766.61"
					x2="248.23"
					y2="764.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.23"
					y1="764.4"
					x2="247.66"
					y2="761.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.66"
					y1="761.48"
					x2="247.53"
					y2="758.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.53"
					y1="758.47"
					x2="247.55"
					y2="756.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.55"
					y1="756.98"
					x2="247.75"
					y2="756.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.75"
					y1="756.31"
					x2="248.18"
					y2="755.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.18"
					y1="755.79"
					x2="248.92"
					y2="755.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.92"
					y1="755.44"
					x2="257.15"
					y2="753.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.15"
					y1="753.11"
					x2="261.23"
					y2="752.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.23"
					y1="752.41"
					x2="265.37"
					y2="752.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.37"
					y1="752.11"
					x2="268.07"
					y2="752.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="268.07"
					y1="698.39"
					x2="264.83"
					y2="698.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.83"
					y1="698.77"
					x2="261.68"
					y2="699.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.68"
					y1="699.6"
					x2="258.34"
					y2="701.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.34"
					y1="701.2"
					x2="256.69"
					y2="702.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.69"
					y1="702.42"
					x2="255.25"
					y2="703.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.25"
					y1="703.84"
					x2="252.92"
					y2="707.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.92"
					y1="707.17"
					x2="251.21"
					y2="710.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="251.21"
					y1="710.95"
					x2="249.96"
					y2="714.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.96"
					y1="714.96"
					x2="249.25"
					y2="718.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.25"
					y1="718.18"
					x2="248.83"
					y2="721.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.83"
					y1="721.44"
					x2="248.77"
					y2="724.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.77"
					y1="724.71"
					x2="249.13"
					y2="727.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.13"
					y1="727.97"
					x2="250.61"
					y2="733.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.61"
					y1="733.02"
					x2="252.9"
					y2="737.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.9"
					y1="737.91"
					x2="255.62"
					y2="742.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.62"
					y1="742.28"
					x2="258.38"
					y2="745.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.86"
					y1="753.11"
					x2="290.34"
					y2="752.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="290.34"
					y1="752.38"
					x2="288.84"
					y2="751.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.84"
					y1="751.27"
					x2="287.54"
					y2="751.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="287.54"
					y1="751.01"
					x2="279.19"
					y2="750.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.19"
					y1="750.3"
					x2="270.82"
					y2="749.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.82"
					y1="749.97"
					x2="268.07"
					y2="749.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.29"
					y1="753.11"
					x2="245.81"
					y2="752.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.81"
					y1="752.38"
					x2="247.3"
					y2="751.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.3"
					y1="751.27"
					x2="248.6"
					y2="751.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.6"
					y1="751.01"
					x2="256.96"
					y2="750.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="256.96"
					y1="750.3"
					x2="265.33"
					y2="749.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.33"
					y1="749.97"
					x2="268.07"
					y2="749.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.87"
					y1="766.97"
					x2="247.62"
					y2="767.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.62"
					y1="767.58"
					x2="249.94"
					y2="768.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.94"
					y1="768.87"
					x2="252.16"
					y2="769.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.16"
					y1="769.58"
					x2="254.48"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.01"
					y1="720.46"
					x2="149.96"
					y2="720.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.01"
					y1="720.46"
					x2="222.01"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.16"
					y1="731.46"
					x2="159.8"
					y2="731.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.8"
					y1="731.46"
					x2="159.8"
					y2="762.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="159.8"
					y1="762.88"
					x2="212.16"
					y2="762.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.16"
					y1="762.88"
					x2="212.16"
					y2="731.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.22"
					y1="729.4"
					x2="157.74"
					y2="729.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.74"
					y1="729.4"
					x2="157.74"
					y2="764.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="157.74"
					y1="764.94"
					x2="214.22"
					y2="764.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="214.22"
					y1="764.94"
					x2="214.22"
					y2="729.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m189.07,755.78c0-1.71-1.38-3.09-3.09-3.09s-3.09,1.39-3.09,3.09,1.38,3.09,3.09,3.09,3.09-1.38,3.09-3.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="188.56 767.91 188.15 763.59 187.81 762.61 187.13 757.15 186.75 756.43 185.98 756.14 185.22 756.43 184.84 757.15 184.16 762.61 183.82 763.59 183.41 767.91 183.9 769.43 185.19 770.36 186.78 770.36 188.07 769.43 188.56 767.91"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m188.56,767.91c0,1.42-1.15,2.57-2.58,2.57s-2.58-1.15-2.58-2.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="183.82"
					y1="763.59"
					x2="183.41"
					y2="767.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m183.82,763.59c.03-.35.15-.68.34-.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.84"
					y1="757.15"
					x2="184.16"
					y2="762.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m184.84,757.15c.07-.58.56-1.01,1.14-1.01s1.07.43,1.14,1.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.81"
					y1="762.61"
					x2="187.13"
					y2="757.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m187.81,762.61c.19.3.31.63.34.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.56"
					y1="767.91"
					x2="188.15"
					y2="763.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="184.58"
					y1="765.34"
					x2="184.58"
					y2="763.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.38"
					y1="763.81"
					x2="187.38"
					y2="765.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="187.38"
					y1="765.34"
					x2="184.58"
					y2="765.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m184.58,763.81c0-.77.63-1.4,1.4-1.4s1.4.63,1.4,1.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m184.16,762.61c.4-.62,1.09-1,1.83-1s1.43.38,1.83,1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="299.49 769.95 299.49 768.9 294.25 768.9 294.25 769.95 299.49 769.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="294.25"
					y1="769.95"
					x2="299.49"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.25"
					y1="768.9"
					x2="294.25"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.49"
					y1="768.9"
					x2="294.25"
					y2="768.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.49"
					y1="769.95"
					x2="299.49"
					y2="768.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="236.66 769.95 241.9 769.95 241.9 768.9 236.66 768.9 236.66 769.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="236.66"
					y1="768.9"
					x2="236.66"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.89"
					y1="768.9"
					x2="236.66"
					y2="768.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.89"
					y1="769.95"
					x2="241.89"
					y2="768.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.66"
					y1="769.95"
					x2="241.89"
					y2="769.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="297.39 768.9 297.39 760.38 296.35 760.38 296.35 768.9 297.39 768.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="296.35"
					y1="768.9"
					x2="297.39"
					y2="768.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="296.35"
					y1="760.38"
					x2="296.35"
					y2="768.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.39"
					y1="760.38"
					x2="296.35"
					y2="760.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.39"
					y1="768.9"
					x2="297.39"
					y2="760.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="238.75 768.9 239.8 768.9 239.8 760.38 238.75 760.38 238.75 768.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="238.75"
					y1="760.38"
					x2="238.75"
					y2="768.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.8"
					y1="760.38"
					x2="238.75"
					y2="760.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.8"
					y1="768.9"
					x2="239.8"
					y2="760.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="238.75"
					y1="768.9"
					x2="239.8"
					y2="768.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="296.35 763 296.35 760.91 239.8 760.91 239.8 763 296.35 763"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="239.8"
					y1="763"
					x2="296.35"
					y2="763"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.8"
					y1="760.91"
					x2="239.8"
					y2="763"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="296.35"
					y1="760.91"
					x2="239.8"
					y2="760.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="296.35"
					y1="763"
					x2="296.35"
					y2="760.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="149.96"
					y1="746.57"
					x2="149.96"
					y2="592.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="70.94"
					y1="746.57"
					x2="149.96"
					y2="746.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="80.3 736.94 139.56 736.94 139.56 603.11 80.3 603.11 80.3 736.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="80.3"
					y1="603.11"
					x2="80.3"
					y2="736.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.56"
					y1="603.11"
					x2="80.3"
					y2="603.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.56"
					y1="736.94"
					x2="139.56"
					y2="603.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="80.3"
					y1="736.94"
					x2="139.56"
					y2="736.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="110.45 723.79 109.92 723.83 109.4 723.97 108.92 724.18 108.48 724.48 108.1 724.84 107.79 725.26 107.57 725.72 107.43 726.21 107.38 726.73 107.43 727.24 107.57 727.73 107.79 728.19 108.1 728.61 108.48 728.97 108.92 729.27 109.4 729.48 109.92 729.62 110.45 729.66 110.98 729.62 111.5 729.48 111.98 729.27 112.42 728.97 112.8 728.61 113.1 728.19 113.33 727.73 113.47 727.24 113.51 726.73 113.47 726.21 113.33 725.72 113.1 725.26 112.8 724.84 112.42 724.48 111.98 724.18 111.5 723.97 110.98 723.83 110.45 723.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="110.98"
					y1="723.83"
					x2="110.45"
					y2="723.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.5"
					y1="723.97"
					x2="110.98"
					y2="723.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.98"
					y1="724.18"
					x2="111.5"
					y2="723.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.42"
					y1="724.48"
					x2="111.98"
					y2="724.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.8"
					y1="724.84"
					x2="112.42"
					y2="724.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.1"
					y1="725.26"
					x2="112.8"
					y2="724.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.33"
					y1="725.72"
					x2="113.1"
					y2="725.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.47"
					y1="726.21"
					x2="113.33"
					y2="725.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.51"
					y1="726.73"
					x2="113.47"
					y2="726.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.47"
					y1="727.24"
					x2="113.51"
					y2="726.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.33"
					y1="727.73"
					x2="113.47"
					y2="727.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="113.1"
					y1="728.19"
					x2="113.33"
					y2="727.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.8"
					y1="728.61"
					x2="113.1"
					y2="728.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.42"
					y1="728.97"
					x2="112.8"
					y2="728.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.98"
					y1="729.27"
					x2="112.42"
					y2="728.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.5"
					y1="729.48"
					x2="111.98"
					y2="729.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.98"
					y1="729.62"
					x2="111.5"
					y2="729.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.45"
					y1="729.66"
					x2="110.98"
					y2="729.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.92"
					y1="729.62"
					x2="110.45"
					y2="729.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.4"
					y1="729.48"
					x2="109.92"
					y2="729.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.92"
					y1="729.27"
					x2="109.4"
					y2="729.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.48"
					y1="728.97"
					x2="108.92"
					y2="729.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.1"
					y1="728.61"
					x2="108.48"
					y2="728.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.79"
					y1="728.19"
					x2="108.1"
					y2="728.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.57"
					y1="727.73"
					x2="107.79"
					y2="728.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.43"
					y1="727.24"
					x2="107.57"
					y2="727.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.38"
					y1="726.73"
					x2="107.43"
					y2="727.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.43"
					y1="726.21"
					x2="107.38"
					y2="726.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.57"
					y1="725.72"
					x2="107.43"
					y2="726.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.79"
					y1="725.26"
					x2="107.57"
					y2="725.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.1"
					y1="724.84"
					x2="107.79"
					y2="725.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.48"
					y1="724.48"
					x2="108.1"
					y2="724.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.92"
					y1="724.18"
					x2="108.48"
					y2="724.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.4"
					y1="723.97"
					x2="108.92"
					y2="724.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.92"
					y1="723.83"
					x2="109.4"
					y2="723.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="110.45"
					y1="723.79"
					x2="109.92"
					y2="723.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="113.09 740.38 113.05 740.82 112.93 741.24 112.74 741.64 112.47 742.01 112.15 742.32 111.77 742.57 111.35 742.76 110.91 742.87 110.45 742.91 109.99 742.87 109.54 742.76 109.13 742.57 108.75 742.32 108.42 742.01 108.16 741.64 107.96 741.24 107.84 740.82 107.8 740.38 108.23 736.13 108.29 735.79 108.4 735.46 108.57 735.16 109.27 729.8 109.32 729.61 109.39 729.43 109.5 729.27 109.63 729.12 109.78 729 109.96 728.91 110.15 728.84 110.35 728.81 110.55 728.81 110.75 728.84 110.94 728.91 111.11 729 111.27 729.12 111.4 729.27 111.51 729.43 111.58 729.61 111.62 729.8 112.32 735.16 112.49 735.46 112.61 735.79 112.67 736.13 113.09 740.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="113.09"
					y1="740.38"
					x2="112.67"
					y2="736.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="112.32"
					y1="735.16"
					x2="111.62"
					y2="729.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.27"
					y1="729.8"
					x2="108.57"
					y2="735.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="108.23"
					y1="736.13"
					x2="107.8"
					y2="740.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="109.01"
					y1="737.85"
					x2="109.01"
					y2="736.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.89"
					y1="736.35"
					x2="111.89"
					y2="737.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.89"
					y1="737.85"
					x2="109.01"
					y2="737.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m112.32,735.16c.19.29.31.62.35.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m109.27,729.8c.07-.57.58-.99,1.17-.99s1.1.42,1.17.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m108.23,736.13c.03-.35.15-.68.35-.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m113.09,740.38c0,1.4-1.18,2.53-2.64,2.53s-2.64-1.13-2.64-2.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m109.01,736.35c0-.76.64-1.38,1.44-1.38s1.44.62,1.44,1.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m108.57,735.16c.41-.61,1.12-.98,1.87-.98s1.46.37,1.87.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.08"
					y1="759.61"
					x2="427.08"
					y2="741.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.08"
					y1="741.28"
					x2="377.34"
					y2="741.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.56"
					y1="759.61"
					x2="366.87"
					y2="759.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.87"
					y1="806.73"
					x2="437.56"
					y2="806.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.56"
					y1="806.73"
					x2="437.56"
					y2="736.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.87"
					y1="736.05"
					x2="366.87"
					y2="806.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.56"
					y1="737.36"
					x2="366.87"
					y2="737.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.34"
					y1="759.61"
					x2="377.34"
					y2="741.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="437.56"
					y1="736.05"
					x2="366.87"
					y2="736.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.61"
					y1="589.79"
					x2="826.44"
					y2="589.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.44"
					y1="589.79"
					x2="826.44"
					y2="587.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="826.44"
					y1="587.17"
					x2="831.61"
					y2="587.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="506.72"
					x2="841.34"
					y2="512.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="516.26"
					x2="841.34"
					y2="522.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="526.32"
					x2="841.34"
					y2="532.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="536.37"
					x2="841.34"
					y2="542.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="546.42"
					x2="841.34"
					y2="552.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="556.47"
					x2="841.34"
					y2="562.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="566.52"
					x2="841.34"
					y2="572.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="576.58"
					x2="841.34"
					y2="582.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="586.63"
					x2="841.34"
					y2="592.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="592.41"
					x2="872.76"
					y2="594.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="597.85"
					x2="872.76"
					y2="604.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="607.9"
					x2="872.76"
					y2="614.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="617.95"
					x2="872.76"
					y2="624.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="628"
					x2="872.76"
					y2="634.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="638.06"
					x2="872.76"
					y2="644.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="648.11"
					x2="872.76"
					y2="654.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="658.16"
					x2="872.76"
					y2="664.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="668.21"
					x2="872.76"
					y2="674.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="678.26"
					x2="872.76"
					y2="684.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="688.32"
					x2="872.76"
					y2="694.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="698.37"
					x2="872.76"
					y2="704.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="708.42"
					x2="872.76"
					y2="714.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="718.48"
					x2="872.76"
					y2="724.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="728.53"
					x2="872.76"
					y2="734.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="738.58"
					x2="872.76"
					y2="744.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="748.63"
					x2="872.76"
					y2="754.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="758.41"
					x2="872.76"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="592.41"
					x2="841.34"
					y2="620.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.76"
					y1="760.35"
					x2="867.9"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.13"
					y1="760.35"
					x2="857.85"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.08"
					y1="760.35"
					x2="847.8"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.03"
					y1="760.35"
					x2="837.75"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="833.98"
					y1="760.35"
					x2="827.69"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.92"
					y1="760.35"
					x2="817.64"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="813.87"
					y1="760.35"
					x2="807.59"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.82"
					y1="760.35"
					x2="797.54"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="793.77"
					y1="760.35"
					x2="787.48"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.71"
					y1="760.35"
					x2="777.43"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.66"
					y1="760.35"
					x2="767.38"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.61"
					y1="760.35"
					x2="757.33"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.56"
					y1="760.35"
					x2="747.27"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.5"
					y1="760.35"
					x2="737.22"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.45"
					y1="760.35"
					x2="727.17"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.4"
					y1="760.35"
					x2="717.12"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.35"
					y1="760.35"
					x2="707.07"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.3"
					y1="760.35"
					x2="697.01"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="693.24"
					y1="760.35"
					x2="686.96"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="683.19"
					y1="760.35"
					x2="676.91"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.14"
					y1="760.35"
					x2="668.28"
					y2="760.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="728.94"
					x2="668.28"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.28"
					y1="728.94"
					x2="668.28"
					y2="791.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="841.34"
					y1="699.35"
					x2="841.34"
					y2="728.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.29"
					y1="163.4"
					x2="395.11"
					y2="163.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="395.11"
					y1="184.34"
					x2="221.29"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.91"
					y1="163.4"
					x2="820.03"
					y2="163.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.03"
					y1="184.34"
					x2="614.91"
					y2="184.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.08"
					y1="798.88"
					x2="377.34"
					y2="798.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.34"
					y1="798.88"
					x2="377.34"
					y2="764.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.34"
					y1="764.84"
					x2="427.08"
					y2="764.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.08"
					y1="764.84"
					x2="427.08"
					y2="798.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="464.45 814.36 464.45 835.3 50 835.3 50 163.39 221.29 163.39 221.29 184.34 70.94 184.34 70.94 579.72 353.56 579.72 353.56 592.81 329.65 592.81 329.65 606.83 316.57 606.83 316.57 592.81 70.94 592.81 70.94 746.57 149.96 746.57 149.96 769.95 316.57 769.95 316.57 690.61 329.65 690.61 329.65 716.14 369.98 716.14 369.98 729.23 360.58 729.23 360.58 814.36 444.8 814.36 444.8 729.23 438.04 729.23 438.04 716.14 457.89 716.14 457.89 814.36 464.45 814.36"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
				<polygon
					points="950 163.39 950 812.71 689.23 812.71 689.23 835.3 563.92 835.3 563.92 814.36 668.28 814.36 668.28 791.76 904.17 791.76 904.17 592.41 929.06 592.41 929.06 184.34 820.02 184.34 820.02 163.39 950 163.39"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
				<polygon
					points="614.91 163.39 614.91 184.34 535.12 184.34 535.12 592.81 437.34 592.81 437.34 579.72 449.97 579.72 449.97 572.74 463.06 572.74 463.06 579.72 522.04 579.72 522.04 445.14 463.06 445.14 463.06 451.01 449.97 451.01 449.97 397.43 463.06 397.43 463.06 402.05 522.04 402.05 522.04 270.53 463.06 270.53 463.06 275.7 449.97 275.7 449.97 184.34 395.1 184.34 395.1 163.39 614.91 163.39"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.08"
				/>
			</g>
			<g id="text">
				<path d="m691.52,756.12v-12.15h4.18c.94,0,1.67.06,2.16.17.7.16,1.29.45,1.78.87.64.54,1.12,1.23,1.43,2.08.32.84.48,1.8.48,2.88,0,.92-.11,1.74-.32,2.45-.22.71-.49,1.3-.83,1.77-.34.46-.71.83-1.11,1.1-.4.27-.88.47-1.45.6-.56.14-1.21.21-1.95.21h-4.38Zm1.61-1.43h2.59c.8,0,1.43-.07,1.88-.22.46-.15.82-.36,1.09-.63.38-.38.68-.89.89-1.53.22-.65.32-1.43.32-2.34,0-1.27-.21-2.25-.63-2.92-.41-.68-.92-1.14-1.52-1.38-.43-.17-1.12-.25-2.08-.25h-2.55v9.28Zm12.77,1.43l-3.22-12.15h1.65l1.85,7.96c.2.83.37,1.66.51,2.49.31-1.3.49-2.05.55-2.25l2.31-8.2h1.94l1.74,6.15c.44,1.52.75,2.96.94,4.3.15-.77.36-1.65.6-2.64l1.91-7.8h1.62l-3.33,12.15h-1.55l-2.56-9.25c-.22-.77-.34-1.25-.38-1.43-.13.56-.25,1.03-.36,1.43l-2.58,9.25h-1.64Z" />
				<path d="m876.5,556.84h-1.71l-2.05-3.43c-.19-.32-.37-.59-.55-.81-.18-.23-.36-.41-.55-.55-.18-.14-.38-.24-.6-.31-.21-.07-.45-.1-.72-.1h-1.18v5.2h-1.43v-12.23h3.65c.53,0,1.03.07,1.48.2.45.13.85.33,1.18.61.34.27.6.61.78,1.02.19.4.28.88.28,1.42,0,.43-.07.82-.2,1.18-.13.35-.31.67-.55.95-.23.28-.52.52-.85.72-.33.19-.7.34-1.12.45v.03c.2.09.38.2.53.32.15.11.3.25.43.41.14.16.27.34.4.55.14.2.29.43.45.7l2.29,3.67Zm-7.33-10.93v4.43h1.94c.36,0,.69-.05.99-.16.31-.11.57-.26.79-.46.22-.2.4-.45.52-.74.13-.3.19-.63.19-.99,0-.65-.21-1.16-.64-1.53-.42-.37-1.03-.55-1.83-.55h-1.96Zm15.68,6.91h-6.16c.02.97.28,1.72.78,2.25.5.53,1.19.79,2.06.79.98,0,1.89-.32,2.71-.97v1.31c-.77.56-1.78.84-3.04.84s-2.2-.4-2.91-1.19c-.7-.8-1.06-1.91-1.06-3.35,0-1.36.38-2.46,1.15-3.32.77-.86,1.73-1.29,2.87-1.29s2.03.37,2.65,1.11c.63.74.94,1.76.94,3.08v.73Zm-1.43-1.19c0-.81-.2-1.44-.59-1.88-.38-.45-.91-.67-1.59-.67s-1.22.24-1.68.71c-.46.47-.74,1.09-.85,1.85h4.71Zm7.7-6.5c-.27-.15-.58-.23-.93-.23-.98,0-1.47.62-1.47,1.85v1.35h2.05v1.19h-2.05v7.54h-1.39v-7.54h-1.49v-1.19h1.49v-1.42c0-.92.26-1.64.79-2.17.53-.53,1.19-.8,1.98-.8.43,0,.76.05,1.01.15v1.26Z" />
				<path d="m205.26,667.19v-18.97h5.4c1.64,0,2.94.4,3.9,1.2.96.8,1.44,1.85,1.44,3.14,0,1.08-.29,2.01-.87,2.8-.58.79-1.38,1.36-2.41,1.69v.05c1.28.15,2.3.64,3.07,1.46.77.81,1.15,1.87,1.15,3.18,0,1.62-.58,2.94-1.75,3.94-1.16,1.01-2.63,1.51-4.41,1.51h-5.53Zm2.22-16.96v6.13h2.28c1.22,0,2.17-.29,2.87-.87.7-.59,1.05-1.42,1.05-2.49,0-1.84-1.21-2.77-3.64-2.77h-2.55Zm0,8.12v6.83h3.02c1.31,0,2.32-.31,3.03-.93.72-.62,1.08-1.46,1.08-2.54,0-2.24-1.53-3.36-4.58-3.36h-2.55Zm22.71,8.84h-2.17v-2.12h-.05c-.94,1.62-2.33,2.43-4.17,2.43-1.35,0-2.41-.36-3.18-1.07-.76-.71-1.14-1.66-1.14-2.84,0-2.53,1.49-4,4.47-4.42l4.06-.57c0-2.3-.93-3.45-2.79-3.45-1.63,0-3.1.56-4.42,1.67v-2.22c1.33-.85,2.87-1.27,4.6-1.27,3.18,0,4.78,1.68,4.78,5.05v8.81Zm-2.17-6.85l-3.27.45c-1.01.14-1.76.39-2.28.75-.51.35-.77.98-.77,1.89,0,.66.23,1.2.7,1.63.48.41,1.11.62,1.89.62,1.08,0,1.96-.37,2.66-1.12.71-.76,1.06-1.72,1.06-2.87v-1.35Zm12.55,6.72c-.51.28-1.19.42-2.02.42-2.37,0-3.56-1.32-3.56-3.97v-8.02h-2.33v-1.85h2.33v-3.31l2.17-.7v4.01h3.41v1.85h-3.41v7.63c0,.91.15,1.56.46,1.94.31.39.82.58,1.53.58.55,0,1.02-.15,1.42-.45v1.85Zm14.15.13h-2.17v-7.81c0-2.82-1.05-4.23-3.15-4.23-1.06,0-1.95.41-2.67,1.23-.72.81-1.08,1.86-1.08,3.14v7.67h-2.17v-20.06h2.17v8.76h.05c1.04-1.71,2.52-2.57,4.45-2.57,3.05,0,4.58,1.84,4.58,5.52v8.35Z" />
				<path d="m545.28,727.28h-10.06v-18.97h9.63v2.01h-7.41v6.31h6.85v2h-6.85v6.64h7.83v2.01Zm14.63,0h-2.17v-7.73c0-2.88-1.05-4.31-3.15-4.31-1.08,0-1.98.41-2.7,1.23-.71.81-1.06,1.84-1.06,3.08v7.73h-2.17v-13.55h2.17v2.25h.05c1.02-1.71,2.5-2.57,4.45-2.57,1.48,0,2.62.48,3.4,1.44.78.95,1.18,2.33,1.18,4.14v8.28Zm10.4-.13c-.51.28-1.19.42-2.02.42-2.37,0-3.56-1.32-3.56-3.97v-8.02h-2.33v-1.85h2.33v-3.31l2.17-.7v4.01h3.41v1.85h-3.41v7.63c0,.91.15,1.56.46,1.94.31.39.82.58,1.53.58.55,0,1.02-.15,1.42-.45v1.85Zm9.99-11.22c-.38-.29-.93-.44-1.64-.44-.93,0-1.7.44-2.33,1.31-.62.87-.93,2.06-.93,3.57v6.91h-2.17v-13.55h2.17v2.79h.05c.31-.95.78-1.69,1.42-2.22.64-.54,1.35-.81,2.13-.81.56,0,1,.06,1.3.19v2.25Zm13.17-2.2l-6.23,15.72c-1.11,2.8-2.67,4.21-4.68,4.21-.56,0-1.04-.06-1.42-.17v-1.94c.47.16.9.24,1.28.24,1.09,0,1.91-.65,2.46-1.96l1.08-2.57-5.29-13.52h2.41l3.66,10.43c.04.13.14.48.28,1.03h.08c.04-.21.13-.55.26-1.01l3.85-10.45h2.25Z" />
				<path d="m205.53,375.14v-18.97h5.4c1.64,0,2.94.4,3.9,1.2.96.8,1.44,1.85,1.44,3.14,0,1.08-.29,2.01-.87,2.8-.58.79-1.38,1.36-2.41,1.69v.05c1.28.15,2.3.64,3.07,1.46.77.81,1.15,1.87,1.15,3.18,0,1.62-.58,2.94-1.75,3.94-1.16,1.01-2.63,1.51-4.41,1.51h-5.53Zm2.22-16.96v6.13h2.28c1.22,0,2.17-.29,2.87-.87.7-.59,1.05-1.42,1.05-2.49,0-1.84-1.21-2.77-3.64-2.77h-2.55Zm0,8.12v6.83h3.02c1.31,0,2.32-.31,3.03-.93.72-.62,1.08-1.46,1.08-2.54,0-2.24-1.53-3.36-4.58-3.36h-2.55Zm23.88,2.61h-9.57c.04,1.51.44,2.67,1.22,3.49s1.84,1.23,3.2,1.23c1.53,0,2.93-.5,4.21-1.51v2.04c-1.19.86-2.77,1.3-4.72,1.3s-3.42-.61-4.51-1.84c-1.09-1.23-1.64-2.97-1.64-5.2,0-2.11.6-3.82,1.79-5.15,1.2-1.33,2.69-2,4.46-2s3.14.57,4.11,1.72c.97,1.15,1.46,2.74,1.46,4.78v1.14Zm-2.22-1.84c0-1.25-.31-2.23-.91-2.92-.59-.7-1.42-1.05-2.47-1.05s-1.89.37-2.61,1.1c-.71.73-1.16,1.69-1.32,2.87h7.32Zm17.05,8.07h-2.17v-2.3h-.05c-1.01,1.75-2.56,2.62-4.66,2.62-1.7,0-3.07-.6-4.09-1.81-1.01-1.22-1.52-2.87-1.52-4.96,0-2.24.56-4.04,1.69-5.38,1.13-1.35,2.63-2.02,4.51-2.02s3.22.73,4.06,2.2h.05v-8.39h2.17v20.06Zm-2.17-6.13v-2c0-1.09-.36-2.02-1.08-2.78-.72-.76-1.64-1.14-2.75-1.14-1.32,0-2.36.49-3.12,1.46-.76.97-1.14,2.31-1.14,4.02,0,1.56.36,2.8,1.08,3.7.73.9,1.71,1.35,2.94,1.35s2.19-.44,2.94-1.31c.76-.87,1.14-1.98,1.14-3.31Zm13.61-5.23c-.38-.29-.93-.44-1.64-.44-.93,0-1.7.44-2.33,1.31-.62.87-.93,2.06-.93,3.57v6.91h-2.17v-13.55h2.17v2.79h.05c.31-.95.78-1.69,1.42-2.22.64-.54,1.35-.81,2.13-.81.56,0,1,.06,1.3.19v2.25Zm8.01,11.67c-2,0-3.6-.63-4.8-1.89-1.19-1.27-1.79-2.95-1.79-5.04,0-2.28.62-4.05,1.87-5.33,1.24-1.28,2.92-1.92,5.04-1.92s3.59.62,4.72,1.87c1.14,1.24,1.71,2.97,1.71,5.17s-.61,3.89-1.84,5.2c-1.22,1.3-2.85,1.94-4.91,1.94Zm.16-12.36c-1.39,0-2.5.48-3.31,1.43-.81.94-1.22,2.25-1.22,3.92s.41,2.87,1.23,3.8c.82.93,1.92,1.39,3.29,1.39s2.48-.45,3.23-1.36c.76-.91,1.14-2.2,1.14-3.88s-.38-3-1.14-3.92c-.75-.92-1.83-1.38-3.23-1.38Zm15.7,12.36c-2,0-3.6-.63-4.8-1.89-1.19-1.27-1.79-2.95-1.79-5.04,0-2.28.62-4.05,1.87-5.33,1.24-1.28,2.92-1.92,5.04-1.92s3.59.62,4.72,1.87c1.14,1.24,1.71,2.97,1.71,5.17s-.61,3.89-1.84,5.2c-1.22,1.3-2.85,1.94-4.91,1.94Zm.16-12.36c-1.39,0-2.5.48-3.31,1.43-.81.94-1.22,2.25-1.22,3.92s.41,2.87,1.23,3.8c.82.93,1.92,1.39,3.29,1.39s2.48-.45,3.23-1.36c.76-.91,1.14-2.2,1.14-3.88s-.38-3-1.14-3.92c-.75-.92-1.83-1.38-3.23-1.38Zm29.27,12.04h-2.17v-7.78c0-1.5-.23-2.58-.7-3.25-.46-.67-1.23-1.01-2.33-1.01-.93,0-1.72.42-2.37,1.27-.64.85-.97,1.86-.97,3.04v7.73h-2.17v-8.04c0-2.66-1.03-4-3.08-4-.95,0-1.74.4-2.36,1.2-.62.79-.93,1.83-.93,3.11v7.73h-2.17v-13.55h2.17v2.14h.05c.96-1.64,2.36-2.46,4.21-2.46.93,0,1.73.26,2.42.78.69.51,1.16,1.19,1.42,2.02,1.01-1.87,2.5-2.8,4.5-2.8,2.98,0,4.47,1.84,4.47,5.52v8.35Z" />
				<path d="m210.96,403.27h-1.58v-11.93c-.12.12-.3.26-.54.42-.23.15-.49.31-.79.46-.29.15-.6.3-.92.43-.32.13-.64.24-.94.32v-1.6c.35-.1.71-.22,1.1-.39.39-.17.77-.35,1.15-.55.38-.21.73-.42,1.07-.64.33-.22.62-.44.87-.65h.6v14.11Zm11.11-10.18c0-.42-.07-.79-.2-1.11-.13-.31-.31-.57-.54-.78-.22-.21-.49-.37-.8-.47s-.64-.15-1-.15c-.31,0-.61.04-.9.13-.3.08-.58.2-.87.35-.28.15-.55.32-.81.53-.26.21-.5.43-.72.68v-1.69c.44-.43.94-.76,1.48-.98.55-.23,1.22-.35,2.01-.35.56,0,1.09.08,1.57.25.48.16.9.4,1.25.71s.63.7.83,1.16c.21.46.31.99.31,1.59,0,.55-.06,1.04-.19,1.48-.12.44-.31.86-.57,1.25-.25.39-.57.77-.95,1.13-.39.36-.84.73-1.36,1.1-.65.46-1.18.86-1.61,1.18-.42.33-.75.64-1,.92-.24.28-.42.57-.52.86-.1.28-.14.61-.14.98h6.87v1.42h-8.52v-.68c0-.59.06-1.11.19-1.56.13-.45.34-.88.64-1.28.3-.4.68-.81,1.16-1.21.48-.4,1.07-.86,1.76-1.37.5-.36.92-.7,1.25-1.03.34-.33.61-.65.82-.98.21-.33.35-.66.43-.99.09-.34.13-.7.13-1.08Z" />
				<rect x="226.85" y="389.46" width="1.4" height="4.3" />
				<path d="m236.72,403.27h-1.58v-11.93c-.12.12-.3.26-.54.42-.23.15-.49.31-.79.46-.29.15-.6.3-.92.43-.32.13-.64.24-.94.32v-1.6c.35-.1.71-.22,1.1-.39.39-.17.77-.35,1.15-.55.38-.21.73-.42,1.07-.64.33-.22.62-.44.87-.65h.6v14.11Z" />
				<path d="m243.36,389.46v4.3h-1.4v-4.3h1.4Zm3.2,0v4.3h-1.4v-4.3h1.4Z" />
				<path d="m262.33,393.41l-3.31,4.99,3.25,4.87h-1.84l-1.93-3.2c-.12-.2-.27-.45-.43-.75h-.04c-.03.06-.18.31-.45.75l-1.97,3.2h-1.82l3.36-4.83-3.22-5.02h1.84l1.91,3.37c.14.25.28.51.41.77h.04l2.46-4.14h1.74Z" />
				<path d="m274.95,403.27h-1.58v-11.93c-.12.12-.3.26-.54.42-.23.15-.49.31-.79.46-.29.15-.6.3-.92.43-.32.13-.64.24-.94.32v-1.6c.35-.1.71-.22,1.1-.39.39-.17.77-.35,1.15-.55.38-.21.73-.42,1.07-.64.33-.22.62-.44.87-.65h.6v14.11Zm11.11-10.18c0-.42-.07-.79-.2-1.11-.13-.31-.31-.57-.54-.78-.22-.21-.49-.37-.8-.47-.31-.1-.64-.15-1-.15-.31,0-.61.04-.9.13-.3.08-.58.2-.87.35-.28.15-.55.32-.81.53-.26.21-.5.43-.72.68v-1.69c.44-.43.94-.76,1.48-.98.55-.23,1.22-.35,2.01-.35.56,0,1.09.08,1.57.25.48.16.9.4,1.25.71s.63.7.83,1.16c.21.46.31.99.31,1.59,0,.55-.06,1.04-.19,1.48-.12.44-.31.86-.57,1.25-.25.39-.57.77-.95,1.13-.39.36-.84.73-1.36,1.1-.65.46-1.18.86-1.61,1.18-.42.33-.75.64-1,.92-.24.28-.42.57-.52.86-.1.28-.14.61-.14.98h6.87v1.42h-8.52v-.68c0-.59.06-1.11.19-1.56.13-.45.34-.88.64-1.28.3-.4.68-.81,1.16-1.21.48-.4,1.07-.86,1.76-1.37.5-.36.92-.7,1.25-1.03.34-.33.61-.65.82-.98.21-.33.35-.66.43-.99.09-.34.13-.7.13-1.08Z" />
				<rect x="290.84" y="389.46" width="1.4" height="4.3" />
				<path d="m294.61,399.42c0-.37.06-.73.17-1.1.12-.37.28-.72.49-1.04.22-.32.48-.61.8-.88.32-.26.68-.47,1.09-.63-.6-.33-1.07-.76-1.42-1.28-.35-.53-.53-1.11-.53-1.74,0-.51.1-.98.29-1.41.2-.43.47-.8.82-1.12.35-.31.76-.56,1.23-.73.47-.18.99-.27,1.54-.27s1.07.09,1.55.27c.47.18.89.43,1.23.74.35.31.62.69.81,1.12.19.43.29.9.29,1.4,0,.64-.18,1.22-.53,1.74-.35.52-.82.95-1.41,1.28.4.15.75.36,1.07.63.31.26.58.56.79.88.22.32.39.67.5,1.04.12.37.17.73.17,1.1,0,.6-.11,1.16-.33,1.66-.22.5-.53.93-.92,1.29-.39.35-.86.63-1.42.83-.55.2-1.15.3-1.81.3s-1.25-.1-1.8-.3c-.55-.2-1.02-.47-1.42-.83-.4-.36-.71-.79-.93-1.29-.22-.5-.33-1.05-.33-1.66Zm1.71-.13c0,.43.06.82.19,1.16.13.35.32.64.56.89.24.24.54.43.88.57.35.13.73.19,1.15.19s.78-.07,1.12-.2c.34-.13.63-.32.88-.57.25-.24.44-.54.58-.89.14-.35.21-.73.21-1.16,0-.39-.07-.74-.2-1.08-.13-.34-.31-.64-.56-.9-.24-.26-.54-.46-.88-.61s-.72-.22-1.15-.22c-.4,0-.77.07-1.11.21-.33.13-.63.33-.88.58-.24.24-.44.54-.58.89-.14.34-.21.72-.21,1.13Zm.49-6.4c0,.33.06.63.17.91.12.28.29.52.49.73.21.21.46.37.73.49.28.12.57.17.89.17s.61-.06.89-.18c.28-.12.53-.29.73-.49.21-.21.37-.46.49-.73.12-.28.18-.58.18-.9s-.06-.64-.18-.92c-.12-.28-.28-.53-.48-.73-.21-.21-.45-.37-.73-.48-.28-.12-.57-.18-.9-.18-.34,0-.65.06-.93.18-.28.12-.52.29-.72.5-.2.21-.35.45-.46.73-.11.28-.16.58-.16.9Z" />
				<path d="m307.35,389.46v4.3h-1.4v-4.3h1.4Zm3.2,0v4.3h-1.4v-4.3h1.4Z" />
				<path d="m725.84,632.22h-3.1l-7.33-8.68c-.27-.33-.44-.55-.5-.66h-.05v9.34h-2.22v-18.97h2.22v8.92h.05c.12-.19.29-.41.5-.65l7.09-8.27h2.77l-8.14,9.1,8.71,9.87Zm3.32-16.99c-.39,0-.72-.13-.99-.4-.27-.26-.41-.6-.41-1.01s.14-.74.41-1.01c.27-.27.6-.41.99-.41s.73.14,1.01.41c.28.26.42.6.42,1.01s-.14.72-.42.99c-.27.27-.61.41-1.01.41Zm1.06,16.99h-2.17v-13.55h2.17v13.55Zm10.66-.13c-.51.28-1.19.42-2.02.42-2.37,0-3.56-1.32-3.56-3.97v-8.02h-2.33v-1.85h2.33v-3.31l2.17-.7v4.01h3.41v1.85h-3.41v7.63c0,.91.15,1.56.46,1.94.31.39.82.58,1.53.58.55,0,1.02-.15,1.42-.45v1.85Zm12.12-.49c-1.04.63-2.28.94-3.7.94-1.93,0-3.49-.63-4.68-1.88-1.18-1.26-1.77-2.89-1.77-4.9,0-2.23.64-4.02,1.92-5.37,1.28-1.36,2.99-2.04,5.12-2.04,1.19,0,2.24.22,3.15.66v2.22c-1.01-.71-2.08-1.06-3.23-1.06-1.38,0-2.52.5-3.41,1.5-.88.99-1.32,2.29-1.32,3.9s.41,2.84,1.24,3.76c.84.92,1.96,1.38,3.36,1.38,1.18,0,2.29-.39,3.33-1.18v2.06Zm14.51.62h-2.17v-7.81c0-2.82-1.05-4.23-3.15-4.23-1.06,0-1.95.41-2.67,1.23-.72.81-1.08,1.86-1.08,3.14v7.67h-2.17v-20.06h2.17v8.76h.05c1.04-1.71,2.52-2.57,4.45-2.57,3.05,0,4.58,1.84,4.58,5.52v8.35Zm14.96-6.23h-9.57c.04,1.51.44,2.67,1.22,3.49.78.82,1.84,1.23,3.2,1.23,1.53,0,2.93-.5,4.21-1.51v2.04c-1.19.86-2.77,1.3-4.72,1.3s-3.42-.61-4.51-1.84c-1.09-1.23-1.64-2.97-1.64-5.2,0-2.11.6-3.82,1.79-5.15,1.2-1.33,2.69-2,4.46-2s3.14.57,4.11,1.72c.97,1.15,1.46,2.74,1.46,4.78v1.14Zm-2.22-1.84c0-1.25-.31-2.23-.91-2.92-.59-.7-1.42-1.05-2.47-1.05s-1.89.37-2.61,1.1c-.71.73-1.16,1.69-1.32,2.87h7.32Zm16.74,8.07h-2.17v-7.73c0-2.88-1.05-4.31-3.15-4.31-1.08,0-1.98.41-2.7,1.23-.71.81-1.06,1.84-1.06,3.08v7.73h-2.17v-13.55h2.17v2.25h.05c1.02-1.71,2.5-2.57,4.45-2.57,1.48,0,2.62.48,3.4,1.44.78.95,1.18,2.33,1.18,4.14v8.28Z" />
				<path d="m628.76,346.89h-9.84v-18.97h2.22v16.96h7.62v2.01Zm3.73-16.99c-.39,0-.72-.13-.99-.4-.27-.26-.41-.6-.41-1.01s.14-.74.41-1.01c.27-.27.6-.41.99-.41s.73.14,1.01.41c.28.26.42.6.42,1.01s-.14.72-.42.99c-.27.27-.61.41-1.01.41Zm1.06,16.99h-2.17v-13.55h2.17v13.55Zm15.03-13.55l-5.4,13.55h-2.13l-5.13-13.55h2.38l3.44,9.84c.26.72.41,1.35.48,1.89h.05c.09-.68.23-1.29.42-1.84l3.6-9.9h2.29Zm3.43-3.44c-.39,0-.72-.13-.99-.4-.27-.26-.41-.6-.41-1.01s.14-.74.41-1.01c.27-.27.6-.41.99-.41s.73.14,1.01.41c.28.26.42.6.42,1.01s-.14.72-.42.99c-.27.27-.61.41-1.01.41Zm1.06,16.99h-2.17v-13.55h2.17v13.55Zm15.62,0h-2.17v-7.73c0-2.88-1.05-4.31-3.15-4.31-1.08,0-1.98.41-2.7,1.23-.71.81-1.06,1.84-1.06,3.08v7.73h-2.17v-13.55h2.17v2.25h.05c1.02-1.71,2.5-2.57,4.45-2.57,1.48,0,2.62.48,3.4,1.44.78.95,1.18,2.33,1.18,4.14v8.28Zm15.65-1.08c0,4.97-2.38,7.46-7.14,7.46-1.68,0-3.14-.32-4.39-.95v-2.17c1.53.85,2.98,1.27,4.37,1.27,3.33,0,5-1.77,5-5.32v-1.48h-.05c-1.03,1.73-2.58,2.59-4.66,2.59-1.68,0-3.04-.6-4.08-1.8-1.02-1.21-1.53-2.83-1.53-4.86,0-2.3.55-4.13,1.65-5.49,1.11-1.36,2.63-2.04,4.55-2.04s3.18.73,4.06,2.2h.05v-1.88h2.17v12.46Zm-2.17-5.04v-2c0-1.08-.37-2-1.1-2.77-.72-.77-1.63-1.15-2.71-1.15-1.34,0-2.39.49-3.15,1.47-.76.97-1.14,2.33-1.14,4.09,0,1.51.36,2.72,1.08,3.63.73.9,1.7,1.35,2.9,1.35s2.21-.43,2.96-1.3c.77-.86,1.15-1.97,1.15-3.32Z" />
				<polygon points="697.29 327.91 688.19 350.03 686.16 350.03 695.24 327.91 697.29 327.91" />
				<path d="m699.5,346.89v-18.97h5.24c6.69,0,10.03,3.08,10.03,9.25,0,2.93-.93,5.28-2.79,7.07-1.85,1.77-4.34,2.66-7.45,2.66h-5.03Zm2.22-16.96v14.95h2.83c2.49,0,4.42-.67,5.81-2,1.38-1.33,2.08-3.22,2.08-5.66,0-4.86-2.58-7.29-7.75-7.29h-2.96Zm17.51-.03c-.39,0-.72-.13-.99-.4-.27-.26-.41-.6-.41-1.01s.14-.74.41-1.01c.27-.27.6-.41.99-.41s.73.14,1.01.41c.28.26.42.6.42,1.01s-.14.72-.42.99c-.27.27-.61.41-1.01.41Zm1.06,16.99h-2.17v-13.55h2.17v13.55Zm15.55,0h-2.17v-7.73c0-2.88-1.05-4.31-3.15-4.31-1.08,0-1.98.41-2.7,1.23-.71.81-1.06,1.84-1.06,3.08v7.73h-2.17v-13.55h2.17v2.25h.05c1.02-1.71,2.51-2.57,4.45-2.57,1.48,0,2.62.48,3.4,1.44.79.95,1.18,2.33,1.18,4.14v8.28Zm5.12-16.99c-.39,0-.72-.13-.99-.4-.27-.26-.41-.6-.41-1.01s.14-.74.41-1.01c.27-.27.6-.41.99-.41s.73.14,1.01.41c.28.26.42.6.42,1.01s-.14.72-.42.99c-.27.27-.61.41-1.01.41Zm1.06,16.99h-2.17v-13.55h2.17v13.55Zm15.55,0h-2.17v-7.73c0-2.88-1.05-4.31-3.15-4.31-1.08,0-1.98.41-2.7,1.23-.71.81-1.06,1.84-1.06,3.08v7.73h-2.17v-13.55h2.17v2.25h.05c1.02-1.71,2.51-2.57,4.45-2.57,1.48,0,2.62.48,3.4,1.44.79.95,1.18,2.33,1.18,4.14v8.28Zm15.57-1.08c0,4.97-2.38,7.46-7.14,7.46-1.68,0-3.14-.32-4.39-.95v-2.17c1.53.85,2.98,1.27,4.37,1.27,3.33,0,5-1.77,5-5.32v-1.48h-.05c-1.03,1.73-2.58,2.59-4.66,2.59-1.68,0-3.04-.6-4.08-1.8-1.02-1.21-1.53-2.83-1.53-4.86,0-2.3.55-4.13,1.65-5.49,1.11-1.36,2.63-2.04,4.55-2.04s3.18.73,4.06,2.2h.05v-1.88h2.17v12.46Zm-2.17-5.04v-2c0-1.08-.37-2-1.1-2.77-.72-.77-1.63-1.15-2.71-1.15-1.34,0-2.39.49-3.15,1.47-.76.97-1.14,2.33-1.14,4.09,0,1.51.36,2.72,1.08,3.63.73.9,1.7,1.35,2.9,1.35s2.21-.43,2.96-1.3c.77-.86,1.15-1.97,1.15-3.32Z" />
				<path d="m799.1,346.89h-2.65l-3.18-5.32c-.29-.49-.57-.91-.85-1.26-.27-.35-.56-.64-.85-.86-.28-.22-.59-.38-.93-.48-.33-.11-.7-.16-1.11-.16h-1.83v8.07h-2.22v-18.97h5.66c.83,0,1.59.11,2.29.32.71.2,1.31.52,1.83.94.52.42.93.95,1.22,1.59.29.63.44,1.36.44,2.21,0,.66-.1,1.27-.3,1.83-.19.55-.48,1.04-.85,1.47-.36.43-.8.8-1.32,1.11-.51.3-1.09.53-1.73.7v.05c.32.14.59.3.82.49.24.18.46.39.67.64.21.25.42.53.62.85.21.31.45.67.7,1.08l3.56,5.7Zm-11.38-16.96v6.88h3.02c.56,0,1.07-.08,1.53-.25.48-.17.89-.41,1.23-.71.34-.32.61-.7.81-1.15.19-.46.29-.97.29-1.53,0-1.01-.33-1.8-.99-2.37-.65-.57-1.6-.86-2.84-.86h-3.04Zm19.27,17.28c-2,0-3.6-.63-4.8-1.89-1.19-1.27-1.79-2.95-1.79-5.04,0-2.28.62-4.05,1.87-5.33,1.24-1.28,2.92-1.92,5.04-1.92s3.59.62,4.72,1.87c1.14,1.24,1.71,2.97,1.71,5.17s-.61,3.89-1.84,5.2c-1.22,1.3-2.85,1.94-4.91,1.94Zm.16-12.36c-1.39,0-2.5.48-3.31,1.43-.81.94-1.22,2.25-1.22,3.92s.41,2.87,1.23,3.8c.82.93,1.92,1.39,3.29,1.39s2.48-.45,3.23-1.36c.76-.91,1.14-2.2,1.14-3.88s-.38-3-1.14-3.92c-.75-.92-1.83-1.38-3.23-1.38Zm15.64,12.36c-2,0-3.6-.63-4.8-1.89-1.19-1.27-1.79-2.95-1.79-5.04,0-2.28.62-4.05,1.87-5.33,1.24-1.28,2.92-1.92,5.04-1.92s3.59.62,4.72,1.87c1.14,1.24,1.71,2.97,1.71,5.17s-.61,3.89-1.84,5.2c-1.22,1.3-2.85,1.94-4.91,1.94Zm.16-12.36c-1.39,0-2.5.48-3.31,1.43-.81.94-1.22,2.25-1.22,3.92s.41,2.87,1.23,3.8c.82.93,1.92,1.39,3.29,1.39s2.48-.45,3.23-1.36c.76-.91,1.14-2.2,1.14-3.88s-.38-3-1.14-3.92c-.75-.92-1.83-1.38-3.23-1.38Zm29.22,12.04h-2.17v-7.78c0-1.5-.23-2.58-.7-3.25-.46-.67-1.23-1.01-2.33-1.01-.93,0-1.72.42-2.37,1.27-.64.85-.97,1.86-.97,3.04v7.73h-2.17v-8.04c0-2.66-1.03-4-3.08-4-.95,0-1.74.4-2.35,1.2-.62.79-.93,1.83-.93,3.11v7.73h-2.17v-13.55h2.17v2.14h.05c.96-1.64,2.36-2.46,4.21-2.46.93,0,1.73.26,2.42.78.69.51,1.16,1.19,1.42,2.02,1.01-1.87,2.51-2.8,4.5-2.8,2.98,0,4.47,1.84,4.47,5.52v8.35Z" />
				<path d="m687.94,375.01h-1.58v-11.93c-.12.12-.3.26-.54.42-.23.15-.49.31-.79.46-.29.15-.6.3-.92.43-.32.13-.64.24-.94.32v-1.6c.35-.1.71-.22,1.1-.39.39-.17.77-.35,1.15-.55.38-.21.73-.42,1.07-.64.33-.22.62-.44.87-.65h.6v14.11Zm11.11-10.18c0-.42-.07-.79-.2-1.11-.13-.31-.31-.57-.54-.78-.22-.21-.49-.37-.8-.47-.31-.1-.64-.15-1-.15-.31,0-.61.04-.9.13-.3.08-.58.2-.87.35-.28.15-.55.32-.81.53-.26.21-.5.43-.72.68v-1.69c.44-.43.94-.76,1.48-.98.55-.23,1.22-.35,2.01-.35.56,0,1.09.08,1.57.25.48.16.9.4,1.25.71s.63.7.83,1.16c.21.46.31.99.31,1.59,0,.55-.06,1.04-.19,1.48-.12.44-.31.86-.57,1.25-.25.39-.57.77-.95,1.13-.39.36-.84.73-1.36,1.1-.65.46-1.18.86-1.61,1.18-.42.33-.75.64-1,.92-.24.28-.42.57-.52.86-.1.28-.14.61-.14.98h6.87v1.42h-8.52v-.68c0-.59.06-1.11.19-1.56.13-.45.34-.88.64-1.28.3-.4.68-.81,1.16-1.21.48-.4,1.07-.86,1.76-1.37.5-.36.92-.7,1.25-1.03.34-.33.61-.65.82-.98.21-.33.35-.66.43-.99.09-.34.13-.7.13-1.08Z" />
				<rect x="703.83" y="361.21" width="1.4" height="4.3" />
				<path d="m716.45,362.13c-.21.37-.47.82-.77,1.37-.3.55-.61,1.16-.94,1.84-.33.68-.67,1.41-1.02,2.19s-.67,1.59-.97,2.43c-.3.83-.57,1.68-.8,2.54-.22.85-.39,1.69-.49,2.52h-1.69c.12-.82.29-1.66.53-2.51.24-.86.52-1.7.82-2.52.31-.83.63-1.62.97-2.39.34-.76.67-1.47.99-2.11.32-.64.61-1.21.88-1.69.27-.49.48-.88.64-1.16h-6.92v-1.42h8.78v.91Z" />
				<path d="m720.34,361.21v4.3h-1.4v-4.3h1.4Zm3.2,0v4.3h-1.4v-4.3h1.4Z" />
				<path d="m739.31,365.16l-3.31,4.99,3.25,4.87h-1.84l-1.93-3.2c-.12-.2-.27-.45-.43-.75h-.04c-.03.06-.18.31-.45.75l-1.97,3.2h-1.82l3.36-4.83-3.22-5.02h1.84l1.91,3.37c.14.25.28.51.41.77h.04l2.46-4.14h1.74Z" />
				<path d="m751.94,375.01h-1.58v-11.93c-.12.12-.3.26-.54.42-.23.15-.49.31-.79.46-.29.15-.6.3-.92.43-.32.13-.64.24-.94.32v-1.6c.35-.1.71-.22,1.1-.39.39-.17.77-.35,1.15-.55.38-.21.73-.42,1.07-.64.33-.22.62-.44.87-.65h.6v14.11Zm12.85-3.91c0,.62-.12,1.19-.36,1.7-.23.51-.56.94-.99,1.31-.42.36-.93.64-1.53.84-.6.2-1.25.3-1.97.3-1.32,0-2.36-.25-3.14-.75v-1.69c.93.73,2,1.1,3.2,1.1.48,0,.91-.06,1.3-.18.39-.12.73-.3,1-.53.28-.23.5-.51.64-.84.15-.33.23-.7.23-1.11,0-1.8-1.28-2.7-3.85-2.7h-1.15v-1.34h1.09c2.27,0,3.41-.85,3.41-2.54,0-1.57-.87-2.35-2.6-2.35-.98,0-1.89.33-2.74.98v-1.53c.88-.53,1.93-.79,3.14-.79.58,0,1.1.08,1.57.24.47.16.87.39,1.2.67s.59.64.77,1.04c.19.4.28.85.28,1.34,0,1.82-.92,2.98-2.75,3.5v.04c.47.05.9.17,1.3.35.4.17.74.4,1.03.68.29.28.51.62.67,1,.17.38.25.8.25,1.26Z" />
				<rect x="767.82" y="361.21" width="1.4" height="4.3" />
				<path d="m780.54,368.06c0,1.16-.11,2.18-.32,3.07-.21.89-.51,1.65-.9,2.26-.39.61-.88,1.07-1.45,1.4-.57.31-1.22.47-1.95.47-.69,0-1.31-.15-1.86-.45-.54-.31-.99-.75-1.37-1.34-.37-.58-.65-1.3-.85-2.15-.19-.85-.29-1.83-.29-2.93,0-1.21.1-2.27.3-3.2.21-.92.5-1.7.9-2.32.39-.63.88-1.1,1.45-1.42.58-.32,1.25-.48,2-.48,2.89,0,4.34,2.36,4.34,7.07Zm-1.62.15c0-3.93-.93-5.89-2.8-5.89-1.97,0-2.96,2-2.96,6,0,3.73.97,5.59,2.9,5.59s2.86-1.9,2.86-5.7Z" />
				<path d="m784.33,361.21v4.3h-1.4v-4.3h1.4Zm3.2,0v4.3h-1.4v-4.3h1.4Z" />
				<path d="m400.7,776.97l-3.41,12.08h-1.66l-2.48-8.83c-.11-.38-.17-.79-.19-1.23h-.03c-.03.42-.11.82-.22,1.21l-2.5,8.84h-1.64l-3.54-12.08h1.56l2.57,9.26c.11.39.17.79.2,1.21h.04c.03-.3.12-.7.26-1.21l2.67-9.26h1.36l2.56,9.33c.09.32.16.7.2,1.13h.03c.02-.29.1-.68.23-1.16l2.47-9.3h1.53Z" />
				<polygon points="407.74 776.97 401.95 791.05 400.66 791.05 406.43 776.97 407.74 776.97" />
				<path d="m409.14,789.05v-12.08h3.33c4.26,0,6.38,1.96,6.38,5.89,0,1.86-.59,3.36-1.78,4.5-1.18,1.13-2.76,1.69-4.74,1.69h-3.2Zm1.41-10.8v9.52h1.8c1.58,0,2.82-.42,3.7-1.27.88-.85,1.32-2.05,1.32-3.6,0-3.09-1.65-4.64-4.94-4.64h-1.89Z" />
				<path d="m892.6,557.03c-.26,0-.49-.09-.67-.28-.18-.19-.27-.41-.27-.67s.09-.49.27-.67c.19-.19.41-.29.67-.29s.49.1.68.29c.19.19.28.41.28.67s-.09.49-.28.67c-.19.19-.41.28-.68.28Z" />
			</g>
		</g>
	)
}

export default PlanR
